const plpSearchThreshold = window.theme.gtmSearchThreshold || 2;
const plpSearchDelay = window.theme.gtmSearchDelayMS || 1200;
let viewPLPDataLayerDelay;
let viewPLPItemListDataLayerDelay;
let clickPLPSortOptionDataLayerDelay;

const viewPLPDataLayerEvent = (helpers, productCardSelector) => {
  if (viewPLPDataLayerDelay) {
    clearTimeout(viewPLPDataLayerDelay);
  }

  const { getRequestParams, getAPIResponse } = helpers;
  const count = getAPIResponse().total || getAPIResponse().products.length;
  const requestParams = getRequestParams();
  const viewFilterEvent = () => {
    var appliedFilters = helpers.getAppliedFilters(true);
    theme.PLPDataLayerEvents.trackEvent(appliedFilters, 'filter', requestParams);
  }

  const viewItemListEvent = (skusComingIntoView = []) => {
    const viewItemListPLPEvent = (itemList = []) => {
      if (!itemList.length) {
        return;
      }
      if (viewPLPItemListDataLayerDelay) {
        clearTimeout(viewPLPItemListDataLayerDelay);
      }

      viewPLPItemListDataLayerDelay = setTimeout(() => {
        let promotionEvent = JSON.parse(
          localStorage.getItem("ga4-promotionView") || "{}"
        );
        const menuNavigationAction = JSON.parse(
          localStorage.getItem("ga4-navigationClick") || "{}"
        );
        const menuNavigationState =
          menuNavigationAction.menu_navigation_state || {};
        const isSearchSuggestions = productCardSelector.includes(
          "product-suggestions"
        );
        let visibleCount = window.viewItemListPLP.length;
        if (isSearchSuggestions && visibleCount > 5) {
          visibleCount = 5;
        }
        theme.PLPDataLayerEvents.setPLPDataLayerEvent({
          event: "view_item_list",
          menu_navigation_state: menuNavigationState,
          ecommerce: Object.assign(promotionEvent, {
            items: itemList,
            item_list_id: plp.item_list_id,
            item_list_name: plp.item_list_name,
            item_list_type: plp.item_list_type,
            item_total_count: count,
            item_visible_count: visibleCount,
          }),
        }, 'ecommerce');
        skusComingIntoView = [];
      }, 1000);
    };

    let productCards = document.querySelectorAll(productCardSelector);
    if (productCards.length) {
      productCards.forEach((card) => {
        let isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
        card.setAttribute("data-visible-by-default", isVisibleNow);
        if (isVisibleNow) {
          skusComingIntoView.push(card.getAttribute("data-sku"));
        }

        const handleIntersection = (entries, observer) => {
          entries.forEach((entry) => {
            const visibleByDefault =
              card.getAttribute("data-visible-by-default") || false;
            isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
            if (entry.intersectionRatio > 0) {
              observer.unobserve(entry.target);

              card.setAttribute("data-visible-in-viewport", isVisibleNow);
              if (isVisibleNow) {
                const allResults = getAPIResponse().products;
                skusComingIntoView.push(card.getAttribute("data-sku"));
                const itemsInViewport = allResults.filter((item) =>
                  skusComingIntoView.includes(item.variants[0].sku)
                );
                window.viewItemListPLP = window.viewItemListPLP || [];
                const items = itemsInViewport.map((item) => {
                  const itemExists = window.viewItemListPLP.find(
                    (listItem) => listItem.item_id === item.variants[0].sku
                  );
                  const index = allResults.findIndex(
                    (result) => result.variants[0].sku === item.variants[0].sku
                  );
                  const productType = item.product_type;
                  const newItem = {
                    index: index + 1,
                    item_id: item.variants[0].sku,
                    item_name: item.title.replace(/["']/g, ""),
                    item_brand: "Lovisa",
                    item_category: productType,
                    item_id: '51189259',
                    item_list_id: plp.item_list_id,
                    item_list_name: plp.item_list_name,
                    price: item.price,
                    quantity: 1,
                    visible_by_default: visibleByDefault,
                  };
                  if (!itemExists) {
                    window.viewItemListPLP.push(newItem);
                  }

                  if (card.getAttribute("data-sku") === item.variants[0].sku) {
                    card.addEventListener("click", () => {
                      // DATALAYER push data
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({ ecommerce: null });
                      let promotionEvent = JSON.parse(
                        localStorage.getItem("ga4-promotionView") || "{}"
                      );
                      const menuNavigationAction = JSON.parse(
                        localStorage.getItem("ga4-navigationClick") || "{}"
                      );
                      const menuNavigationState =
                        menuNavigationAction.menu_navigation_state || {};
                      theme.PLPDataLayerEvents.setPLPDataLayerEvent({
                        event: "select_item",
                        menu_navigation_state: menuNavigationState,
                        ecommerce: Object.assign(promotionEvent, {
                          item_list_id: plp.item_list_id,
                          item_list_name: plp.item_list_name,
                          item_list_type: plp.item_list_type,
                          items:  [newItem],
                        }),
                      }, 'ecommerce');
                    });
                  }
                  return newItem;
                });
                viewItemListPLPEvent(items);
              }
            }
          });
        };
        const observer = new IntersectionObserver(handleIntersection);
        observer.observe(card);
      });
    }
  };
  viewPLPDataLayerDelay = setTimeout(() => {
    viewFilterEvent();
    viewItemListEvent();
  }, plpSearchDelay);
};

var TagalysCustomisationsCollection = TagalysCustomisationsCollection || {};
var plp_params = {
  collectionId: window.plp_vars.plp_id,
};
var plp_selector = "[data-widget=product-listing-page-container]";
var Firstfilter = 0;
// inline ad functions read the metaobject info and display the inline ad

/**
 * Checks if an inline ad is currently active based on the provided timestamps.
 * 
 * @param {Object} inputTimestamp - An object containing date_from and optionally date_to timestamps.
 * @param {number} inputTimestamp.date_from - The start timestamp in seconds.
 * @param {number} [inputTimestamp.date_to] - The optional end timestamp in seconds.
 * @returns {boolean} - Returns true if the current date is within the range specified by date_from and date_to, otherwise false.
 */
const isActiveInlineAd = (inputTimestamp) => {
  const currentDate = new Date();
  const start = new Date(inputTimestamp.date_from * 1000);
  
  // check if the input date has date_to and compare with the current date if current date is less than the date_to then return true
  if (inputTimestamp.date_to) {
    const end = new Date(inputTimestamp.date_to * 1000);
    return currentDate > start && currentDate < end;
  } else {
    return currentDate > start;

  }
  
};

/**
 * set default current language to 'en'
 * 
 * @type {string}
 * */
let currentLang = 'en';


/**
 * filter the metaobject array to get the unique position
 * if the position is same then filter the metaobject based on the date_from
 *  
 * @param {Array} metaObjArrayInput - An array of metaobjects
 * @returns {Array} - Returns an array of unique metaobjects based on position and date_from
 * */

const filterSamePosition = (metaObjArrayInput) => {
  // Step 1: Sort the array by position and then by date_from in descending order
  metaObjArrayInput.sort((a, b) => {
    if (a.position === b.position) {
      return b.date_from - a.date_from; // Newest date_from first
    }
    return a.position - b.position; // Ascending order of position
  });

  // Step 2: Filter unique positions
  const uniquePositions = new Map();
  const filteredArray = metaObjArrayInput.filter(item => {
    if (!uniquePositions.has(item.position)) {
      uniquePositions.set(item.position, true);
      return true;
    }
    return false;
  });

  return filteredArray;
  
}
/**
 * filter the close position metaobject array to make sure the ad is not come close to each other
 * if the position is close to each other then filter will keep the posistions have one space between them
 *  @param {Array} metaObjArrayInput - An array of metaobjects
 *  @returns {Array} - Returns an array of metaobjects with positions that are not close to each other
 * * */
const filterClosePositions = (metaObjArrayInput, threshold = 1) => {
  // Step 1: Sort the array by position in ascending order
  metaObjArrayInput.sort((a, b) => a.position - b.position);

  // Step 2: Filter close positions
  const filteredArray = [];
  let lastPosition = null;

  for (let i = 0; i < metaObjArrayInput.length; i++) {
    const currentItem = metaObjArrayInput[i];
    
    // If lastPosition is null or the difference between current and last position is greater than the threshold
    if (lastPosition === null || currentItem.position - lastPosition > threshold) {
      filteredArray.push(currentItem);
      lastPosition = currentItem.position;
      
    }
  }

  return filteredArray;

};
/**
 * filter the metaobject array to get the valid metaobjects for the current collection
 * if the collection is not empty then filter the metaobject based on the collection
 * if the exclusion_collection is not empty then filter the metaobject based on the exclusion_collection
 * @param {Array} omniInlineAdObjArray - An array of metaobjects will show on all collection except the collection in exclusion_collection
 * @param {Array} plpInlineAdObjArray - An array of metaobjects will only show on the collection in collection property 
 * @returns {Array} - Returns an array of metaobjects valid for the current collection
 * */

const filterForCurrentCollection = (omniInlineAdObjArray, plpInlineAdObjArray) => {
  // filter metaobjects valid for the current collection
  const plpIncludeOmniObjItem = (plpObjItem) => {
    if (plpObjItem.collection && plpObjItem.collection.length) {
      const collectionIdArray = plpObjItem.collection.map((item) => {
        const parts = item.split('/');
        const lastPart = parts.pop();
        const id_result = Number(lastPart);
        return id_result;

      });
      return collectionIdArray.includes(window.theme.collectionId);
    } else {
      return false;
    }
  };



  const checkExclusionOmniObjItem = (omniObjItem) => {
    if (omniObjItem.exclusion_collection && omniObjItem.exclusion_collection.length) {
      const collectionIdArray = omniObjItem.exclusion_collection.map((item) => {
        const parts = item.split('/');
        const lastPart = parts.pop();
        const id_result = Number(lastPart);
        return id_result;
      });
  
      return !collectionIdArray.includes(window.theme.collectionId);
    } else {
      return true;
    }
  };
  
  // Function to filter omniInlineAdObjArray based on the given conditions
  const filterOmniInlineAdObjArray = (inputArray, type) => {
    const collectionType = type === 'exclude' ? true : false;
    if (inputArray && inputArray.length && window.theme.collectionId) {
      const filteredArray = collectionType ? inputArray.filter(checkExclusionOmniObjItem) : inputArray.filter(plpIncludeOmniObjItem);
      return filteredArray;
    } else {
      return [];
    }
  };
  
 
  
  const filteredOnmiArray = filterOmniInlineAdObjArray(omniInlineAdObjArray, 'exclude');
  const filteredPlpArray = filterOmniInlineAdObjArray(plpInlineAdObjArray, 'include');

  const mergedArray = filteredOnmiArray.concat(filteredPlpArray);

  return mergedArray;
};


const inline_ad_metaobject = window.theme.omniInlineAdMetaobjects;

const omni_plp_inline_ad_array = window.theme.omniInlineAdMetaobjects ? JSON.parse(window.theme.omniInlineAdMetaobjects) : [];
const plp_inline_ad_array = window.theme.plpInlineAdMetaobjects ? JSON.parse(window.theme.plpInlineAdMetaobjects) : [];
const array_after_filter = filterForCurrentCollection(omni_plp_inline_ad_array, plp_inline_ad_array);

const removeSamePositionAds = filterSamePosition(array_after_filter);
const removeClosePositionAds = filterClosePositions(removeSamePositionAds, 1);

const calculateInsertionIndices = (positionArray) => {
  // Extract positions and items from positionArray
  // Sort positions and corresponding items
  const sortedIndices = positionArray.sort((a, b) => a.position - b.position);

  const insertIndexArray = sortedIndices.map((item, index) => {
      const indexOfPosition = item.position - 1;
      const resultIndex = indexOfPosition - index;
      return { resultIndex: resultIndex, item: item };
  }
  );
  
  return insertIndexArray.reduce((acc, item) => {
    acc[item.resultIndex] = item.item.position;
    return acc;
  }, {})
}
// the object will have the index as the key and the position as the value for the insertion the ad in this collection.
const mappingIndexObj = calculateInsertionIndices(removeClosePositionAds);


var promo_multibuy = 0;
var productListingPageTemplates = {
  widget: {
    labels: {
      searchResults: {
        heading: {
          standard: "{{resultsCount}} search results for '{{searchTerm}}'",
          corrected:
            "No results for '{{originalSearchTerm}}'. Showing {{resultsCount}} results for '{{correctedSearchTerm}}' instead",
          partialMatches:
            "No products exactly match '{{searchTerm}}'. Showing products that partially match.",
        },
        productsCount: "({{productsCount}})",
        noResultsHeading: {
          heading: "Sorry! We couldn’t find any search results for ",
          subHeading:
            "Try searching again using a different keyword or spelling",
        },
      },
      filters: {
        heading: "Filters",
        clearAllFilters: "Clear all",
        clearIndividualFilter: "Clear",
        drawerFilterToggle: "Filter by",
        rangeFilterValueSeparator: "to",
      },
      sortOptions: {
        sortBy: "Sort by",
      },
      pagination: {
        firstPage: "First",
        previousPage: "Previous",
        nextPage: "Next",
        loadNext: "Load more",
        loading: "Loading...",
      },
    },
    options: {
      includeTagalysCSS: false,
      canAppendQueryStringToUrl: true,
      perPage: window.plp_vars.plp_limit,
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      if (helpers.isInitialLoading()) {
        return html`<${args.templates.loader} />`;
      }

      var classes = ["plp", "search-results", "page-width"];
      if (helpers.isFilterDrawerOpen()) {
        classes.push("filter-drawer-opened");
      }

      if (helpers.isLoading()) {
        classes.push("loading");
      }

      if (helpers.canShowFiltersInDrawer()) {
        classes.push("show-filters-in-drawer");
      }

      var className = classes.join(" ");

      var totalpagecount = helpers.getCurrentPage() * window.plp_vars.plp_limit;
      if (totalpagecount > helpers.getTotalProductsCount()) {
        totalpagecount = helpers.getTotalProductsCount();
      }
      var filters = helpers.getFilters();
      var appliedFilters = helpers.getAppliedFilters(true);
      var showClearAllFiltersAction = appliedFilters.length;

      return html`
              <div class=${className}>
                <${args.templates.header} />
                <div class="grid grid__uniform collection__container">
                  <div class="grid__item collection-sorting">
                    <div class="filter-main">
                      <div class="hide-filter">                     
                        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g id="&#60;&#60;">
                          <path id="Line 210" d="M6 0.75L1.5 6L6 11.25" stroke="#333333" stroke-width="1.125"/>
                          <path id="Line 211" d="M9.60004 0.75L5.10004 6L9.60004 11.25" stroke="#333333" stroke-width="1.125"/>
                          </g>
                        </svg>
                        <span>Hide Filter<span class="hide-filter-space">(${helpers.getTotalProductsCount()})</span></span>
                      </div>
                      <div class="show-filter" style="display:none;">
                        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.72563 4.33331H13.125C13.6082 4.33331 14 4.72506 14 5.20831C14 5.69156 13.6082 6.08331 13.125 6.08331H7.72563C7.36528 7.10286 6.39294 7.83331 5.25 7.83331C4.10706 7.83331 3.13472 7.10286 2.77437 6.08331H0.875C0.391751 6.08331 0 5.69156 0 5.20831C0 4.72506 0.391751 4.33331 0.875 4.33331H2.77437C3.13472 3.31377 4.10706 2.58331 5.25 2.58331C6.39294 2.58331 7.36528 3.31377 7.72563 4.33331ZM3.73412 6.08331C3.72631 6.06981 3.71867 6.05619 3.71122 6.04247C3.57651 5.7945 3.5 5.51034 3.5 5.20831C3.5 4.88956 3.58522 4.59071 3.73412 4.33331C4.0367 3.81024 4.60225 3.45831 5.25 3.45831C5.89775 3.45831 6.4633 3.81024 6.76588 4.33331C6.77369 4.34682 6.78133 4.36043 6.78878 4.37416C6.92349 4.62212 7 4.90628 7 5.20831C7 5.52706 6.91478 5.82591 6.76588 6.08331C6.4633 6.60639 5.89775 6.95831 5.25 6.95831C4.60225 6.95831 4.0367 6.60639 3.73412 6.08331Z" fill="#333333"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.27437 11.9166H0.875C0.391751 11.9166 0 12.3084 0 12.7916C0 13.2749 0.391751 13.6666 0.875 13.6666H6.27437C6.63472 14.6862 7.60706 15.4166 8.75 15.4166C9.89294 15.4166 10.8653 14.6862 11.2256 13.6666H13.125C13.6083 13.6666 14 13.2749 14 12.7916C14 12.3084 13.6083 11.9166 13.125 11.9166H11.2256C10.8653 10.8971 9.89294 10.1666 8.75 10.1666C7.60706 10.1666 6.63472 10.8971 6.27437 11.9166ZM10.2659 11.9166C10.4148 12.174 10.5 12.4729 10.5 12.7916C10.5 13.0937 10.4235 13.3778 10.2888 13.6258C9.99244 14.1713 9.41447 14.5416 8.75 14.5416C8.10225 14.5416 7.5367 14.1897 7.23412 13.6666C7.09933 13.4336 7.01672 13.1666 7.00228 12.8817C7.00077 12.8519 7 12.8218 7 12.7916C7 12.4896 7.07651 12.2054 7.21122 11.9575C7.21867 11.9437 7.22631 11.9301 7.23412 11.9166C7.5367 11.3936 8.10225 11.0416 8.75 11.0416C9.39775 11.0416 9.9633 11.3935 10.2659 11.9166Z" fill="#333333"/>
                        </svg>
                        <span>Show Filter<span class="hide-filter-space">(${helpers.getTotalProductsCount()})</span></span>
                      </div>
                    </div>
                    
                    <div class="collection__filters">
                      <div class="collection__filter-wrap ">
                        <div class="collection-sort-block">
                          <${args.templates.productListHeader} />
                        </div>
                        <div class="collection-product-per-page-main">
  
                           <${args.templates.productsPerPage}/>
                        </div>
                        <div class="viewing-main">
                            <div class="viewing-type-3">
                              <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="0.350037" y="0.25" width="5.5" height="19.5" rx="1.75" fill="white" stroke="#999999" stroke-width="0.5"/>
                                  <rect x="8.35004" y="0.25" width="5.5" height="19.5" rx="1.75" fill="white" stroke="#999999" stroke-width="0.5"/>
                                  <rect x="16.35" y="0.25" width="5.5" height="19.5" rx="1.75" fill="white" stroke="#999999" stroke-width="0.5"/>
                                </svg>
                            </div>
                            <div class="viewing-type-4 active">
                              
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.350098" y="0.25" width="8.5" height="8.5" rx="0.75" fill="white" stroke="#999999" stroke-width="0.5"/>
                            <rect x="11.35" y="0.25" width="8.5" height="8.5" rx="0.75" fill="white" stroke="#999999" stroke-width="0.5"/>
                            <rect x="0.350037" y="11.25" width="8.5" height="8.5" rx="0.75" fill="white" stroke="#999999" stroke-width="0.5"/>
                            <rect x="11.3499" y="11.25" width="8.5" height="8.5" rx="0.75" fill="white" stroke="#999999" stroke-width="0.5"/>
                            </svg>

                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid__item small-down--one-whole medium-up--one-whole filter-wrapper" style="display:none;">
                    <div class="flex filters-action-block" style="display:none;">
                      <span class="result-counter">
                        ${
                          helpers.getTotalProductsCount() > 1
                            ? `${helpers.getTotalProductsCount()} Results`
                            : `${helpers.getTotalProductsCount()} Result`
                        }
                      </span>
                      <div id="toggle-tg-filter-v2" class="toggle-tg-filter">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-filter"
                          fill="none"
                          viewBox="0 11 20 20"
                          tabindex="-1"
                        >
                          <line x1="16.5" y1="17.5" x2="3.5" y2="17.5" stroke="#3F7972" stroke-linecap="round"></line>
                          <line x1="16.5" y1="24.5" x2="3.5" y2="24.5" stroke="#3F7972" stroke-linecap="round"></line>
                          <circle cx="13" cy="24.5" r="2" fill="white" stroke="#3F7972"></circle>
                          <circle cx="7" cy="17.5" r="2" fill="white" stroke="#3F7972"></circle>
                        </svg>
                        <span class="mobile-facets__open-label button-label">Filter </span>
                      </div>
                    </div>
                    
                  </div>
                  <div class="grid__item one-whole search-result-count" style="display:none;">Showing <span>${
                    helpers.getCurrentPage() * window.plp_vars.plp_limit -
                    (window.plp_vars.plp_limit - 1)
                  } - ${totalpagecount}</span> of ${helpers.getTotalProductsCount()} Results</div>
                  <div class="collection-products-main">
                  <div class="medium-up--one-fifth grid__item collection_tg_filter-wrap ${helpers.canShowFiltersInDrawer() ? `` : `open`}">
                  <div class="collection_tg_filter_mobile_footer">
                      <div class="filter__label clear-all-filters" onclick=${() => {
                        helpers.clearAllFilters();
                        clearAllFilterDataLayerEvent(props);
                      }}>
                      ${
                        showClearAllFiltersAction > 0
                          ? html`
                        Clear`
                          : "Clear"
                      }
                      </div>
                      <div class="apply-filter-count" onClick=${
                        props.helpers.closeFilterDrawer
                      }>Apply<span class="mobile-totalCount">${
        helpers.getTotalProductsCount()
          ? "(" + helpers.getTotalProductsCount() + ")"
          : ""
      }</span></div>
                  </div>
                  <div class="collection_tg_filter_mobile_header">
                    <div>${window.plp_vars.collectionName}</div>
                    <div class="close-filter filter-drawer-toggle" onClick=${
                      props.helpers.closeFilterDrawer
                    }>
                  
                      
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path id="close" d="M1.369 0.234883C1.05582 -0.0782944 0.548061 -0.0782944 0.234883 0.234883C-0.0782944 0.548061 -0.0782944 1.05582 0.234883 1.369L4.86588 6L0.234931 10.631C-0.0782463 10.9441 -0.0782466 11.4519 0.234931 11.7651C0.548109 12.0782 1.05587 12.0782 1.36905 11.7651L6 7.13412L10.631 11.7651C10.9441 12.0782 11.4519 12.0782 11.7651 11.7651C12.0782 11.4519 12.0782 10.9441 11.7651 10.631L7.13412 6L11.7651 1.369C12.0783 1.05582 12.0783 0.548061 11.7651 0.234883C11.4519 -0.0782944 10.9442 -0.0782944 10.631 0.234883L6 4.86588L1.369 0.234883Z" fill="#333333"/>
                      </svg>
                    </div>
                  </div>
                  <div class="mobile-appliedFilters collection__filter-actions">
                  <${args.templates.appliedFilters} />
        
                  </div>
                  <${args.templates.filters} />
                  <${args.templates.productsPerPage}/>
                  </div>
                  <div class="collection__products grid__item medium-up--one-whole medium-up--four-fifths">
                      <div class="collection__filter-actions">
                      <${args.templates.appliedFilters} />
                      
              </div>
                    <div role="list" class="grid grid--flex display--grid">
                      <${args.templates.products} />
                      <${args.templates.productListFooter} />
                    </div>
                    ${
                      helpers.isFilterDrawerOpen()
                        ? html`
                          <div class="filter-overlay" onclick=${helpers.closeFilterDrawer} />
                        `
                        : ""
                    }
                  </div>
                  </div>
                </div>
                <${args.templates.footer} />
              </div>
            `;
    },
  },
  header: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var filterOptions = helpers.getTemplateOptions("filters");
      return html`
              <div class="plp-header">
                <div class="collection__tabs">
                  <div id="toggle-tg-filter" class="collection__tab collection__tab--filter filter-drawer-toggle" onclick=${
                    helpers.openFilterDrawer
                  }>
                    <span class="filter-drawer-btn open-filter-drawer">
                      
                      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.62197 3.14282H11.25C11.6642 3.14282 12 3.47861 12 3.89282C12 4.30704 11.6642 4.64282 11.25 4.64282H6.62197C6.31309 5.51672 5.47966 6.14282 4.5 6.14282C3.52034 6.14282 2.68691 5.51672 2.37803 4.64282H0.75C0.335786 4.64282 0 4.30704 0 3.89282C0 3.47861 0.335786 3.14282 0.75 3.14282H2.37803C2.68691 2.26893 3.52034 1.64282 4.5 1.64282C5.47966 1.64282 6.31309 2.26893 6.62197 3.14282ZM3.20067 4.64282C3.19398 4.63125 3.18743 4.61958 3.18104 4.60781C3.06558 4.39527 3 4.15171 3 3.89282C3 3.61961 3.07305 3.36345 3.20067 3.14282C3.46003 2.69447 3.94479 2.39282 4.5 2.39282C5.05521 2.39282 5.53997 2.69447 5.79933 3.14282C5.80602 3.1544 5.81257 3.16607 5.81896 3.17783C5.93442 3.39037 6 3.63394 6 3.89282C6 4.16604 5.92695 4.42219 5.79933 4.64282C5.53997 5.09117 5.05521 5.39282 4.5 5.39282C3.94479 5.39282 3.46003 5.09117 3.20067 4.64282Z" fill="#333333"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.37803 9.35706H0.75C0.335787 9.35706 0 9.69284 0 10.1071C0 10.5213 0.335787 10.8571 0.75 10.8571H5.37803C5.68691 11.7309 6.52034 12.3571 7.5 12.3571C8.47966 12.3571 9.31309 11.7309 9.62197 10.8571H11.25C11.6642 10.8571 12 10.5213 12 10.1071C12 9.69284 11.6642 9.35706 11.25 9.35706H9.62197C9.31309 8.48316 8.47966 7.85706 7.5 7.85706C6.52034 7.85706 5.68691 8.48316 5.37803 9.35706ZM8.79933 10.8571C8.80602 10.8455 8.81257 10.8338 8.81896 10.822C8.93442 10.6095 9 10.3659 9 10.1071C9 9.83384 8.92695 9.57769 8.79933 9.35706C8.53997 8.9087 8.05521 8.60706 7.5 8.60706C6.94479 8.60706 6.46003 8.9087 6.20067 9.35706C6.19398 9.36863 6.18743 9.3803 6.18104 9.39207C6.06558 9.60461 6 9.84817 6 10.1071C6 10.3803 6.07305 10.6364 6.20067 10.8571C6.46003 11.3054 6.94479 11.6071 7.5 11.6071C8.05521 11.6071 8.53997 11.3054 8.79933 10.8571Z" fill="#333333"/>
                      </svg>

                      Filter
                      <span class="collection__tab--results-no "> ${
                        helpers.getTotalProductsCount()
                          ? "(" + helpers.getTotalProductsCount() + ")"
                          : ""
                      }</span>
                    </span>
                    <span class="filter-drawer-btn close-filter-drawer" onClick=${
                      props.helpers.closeFilterDrawer
                    }>
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        class="icon icon-minus"
                      >
                        <path
                          d="M3.333 8h9.334"
                          stroke="currentColor"
                          stroke-linecap="round"
                          vector-effect="non-scaling-stroke"
                        ></path></svg
                      >Filter
                      <span class="collection__tab--results-no"> ${
                        helpers.getTotalProductsCount()
                          ? "(" + helpers.getTotalProductsCount() + ")"
                          : ""
                      }</span>
                    </span>
                  </div>
                  <div class="collection__tab collection__tab--clear medium-up--hide">
                    <div class="clear-filters__container" style="display: none;">
                      <button type="reset" class="filter__label clear-filters__btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
                          <path
                            fill="#333"
                            d="M4.5,143.621915 L8.12191516,140 L9,140.878085 L5.37808484,144.5 L9,148.121915 L8.12191516,149 L4.5,145.378085 L0.878084836,149 L-5.68434189e-13,148.121915 L3.62191516,144.5 L-5.68434189e-13,140.878085 L0.878084836,140 L4.5,143.621915 Z"
                            transform="translate(0 -140)"
                          ></path>
                        </svg>
                        <span>Clear Filters</span>
                      </button>
                    </div>
                  </div>
                  <div class="collection__tab collection__tab--grid medium-down--hide medium-up--one-sixth">
                    <div></div>
                  </div>
                  <div class="collection__tab collection__tab--sort medium-up--one-sixth">
                    <div class="collection__tab--sort-overlay">
                      <span>
                        Sort By
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
                      <path d="M2.1 0.107664L0.875 0.10769L6.99999 5.89242L13.125 0.107714L11.9 0.107688L7.00001 0.107714L2.1 0.107664Z" fill="#333333"/>
                      </svg>
                      </span>
                    </div>
                    ${
                      filterOptions.includeSortOptionsInFilters
                        ? ""
                        : html`
                          <${args.templates.sortOptions} />
                        `
                    }
                  </div>
                </div>
              </div>
            `;
    },
  },
  productReviews: {
    // Custom template to render variants
    render: function (html, args) {
      var product = args.props.product;
      if (
        typeof product.metafields.okendo == "undefined" ||
        typeof product.metafields.okendo.summaryData == "undefined" ||
        typeof product.metafields.okendo.StarRatingSnippet == "undefined"
      ) {
        return null;
      }
      var reviewCount = product.metafields.okendo.summaryData.value.reviewCount;
      var reviewCountStr = `<span class="reviews-count">(${reviewCount})</span>`;
      if (reviewCount == 0) {
        reviewCountStr = "";
      }
      var starRattingSnippet =
        product.metafields.okendo.StarRatingSnippet.value.replaceAll(
          ["#oke-star-"],
          "#lovisa-star-"
        ) + reviewCountStr;
      return html`<div class="pd-reviews-block" dangerouslySetInnerHTML=${{
        __html: starRattingSnippet,
      }}></div>`;
    },
  },
  product: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var product = props.product;
      var price = product.price;
      var compareAtPrice = product.compare_at_price;

      var productOptions = helpers.getTemplateOptions("product");

      console.log('Product', product.id, product);
      console.log('helpers.isProductOnSale( compareAtPrice, price )', product.id, helpers.isProductOnSale( compareAtPrice, price ), compareAtPrice, price);

      // Retrieve the product link using the productPageUrl helper
      var productLink = productOptions.productPageUrl(product);
      var variants = product.variants;
      var tags = product.tags;
      var badge = "";
      var offer = "";
      var offerProperty = "";
      var badgeStyles = "";
      var isOnlyInStore = false;
      var isOnlyInStoreClass = "";
      var fomoBadgeStyle = "";
      var promo_text = "";
      var promo_style = "";
      var promo_link = "";
      
      var sortedVariants = variants.sort((a, b) => {
        return a.price - b.price;
      });
      var firstAvailableVariant = sortedVariants.find(variant => variant.available === true);
      if(firstAvailableVariant){
        price = firstAvailableVariant.price;
        compareAtPrice = firstAvailableVariant.compare_at_price;
      }
      if (tags.length) {
        tags.forEach(function (tag) {
          if (tag === "in-store") {
            isOnlyInStore = true;
            isOnlyInStoreClass = "hide";
          }
          if (tag.includes("offer:")) {
            var badgeParts = tag.split(":");
            offer = badgeParts[1];
          }
        });
        if (offer != "") {
          offerProperty = offer.replace("-for-", "-");
        }
      } 
      if (!badge) {
        var collections = product.collections;
        var collectionsMetaObject = window.theme.collectionMetaobjects;
        var tempbadge = false;
        // Quickview two badge
        var quickviewBadgeCounter = 0;
        var quickviewBadgeHtml = "";

        for (var i = 0; i < collectionsMetaObject.length; i++) {
          for (var j = 0; j < collections.length; j++) {
            if (
              collections[j].title == collectionsMetaObject[i].collection_name
            ) {
              var quickviewbadgestyle = "";
              var quickviewbadgeClass = "";
              quickviewbadgestyle = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
              quickviewbadgestyle = `${quickviewbadgestyle}; color:  ${collectionsMetaObject[i].badge_text_color};`;
              if (collectionsMetaObject[i].badge_border_color) {
                quickviewbadgestyle = `${quickviewbadgestyle}; border-color:${collectionsMetaObject[i].badge_border_color};`;
              }
              if (collectionsMetaObject[i].opacity) {
                quickviewbadgestyle = `${quickviewbadgestyle}; opacity:${collectionsMetaObject[i].opacity};`;
              }
              if (collectionsMetaObject[i].fomo_style == true) {
                quickviewbadgeClass = "fomo-badge";
              } else if (collectionsMetaObject[i].default_style == true) {
                quickviewbadgeClass = "default-badge";
              }
              quickviewBadgeHtml = html`${quickviewBadgeHtml}<div data-product-card-badge="9716480573767" data-badgestr="${collectionsMetaObject[i].badge_text}" class="product-card__badge ${quickviewbadgeClass}" style="${quickviewbadgestyle}">${collectionsMetaObject[i].badge_text}</div>`;
              quickviewBadgeCounter++;
              if (quickviewBadgeCounter >= 2) {
                break;
              }
            }
          }
        }
        for (var i = 0; i < collectionsMetaObject.length; i++) {
          for (var j = 0; j < collections.length; j++) {
            if (
              collections[j].title == collectionsMetaObject[i].collection_name
            ) {
              badge = collectionsMetaObject[i].badge_text;
              badgeStyles = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
              badgeStyles = `${badgeStyles}; color:  ${collectionsMetaObject[i].badge_text_color};`;
              if (collectionsMetaObject[i].badge_border_color) {
                badgeStyles = `${badgeStyles}; border-color:${collectionsMetaObject[i].badge_border_color};`;
              }
              if (collectionsMetaObject[i].opacity) {
                badgeStyles = `${badgeStyles}; opacity:${collectionsMetaObject[i].opacity};`;
              }
              if (collectionsMetaObject[i].fomo_style == true) {
                fomoBadgeStyle = "fomo-badge";
              } else if (collectionsMetaObject[i].default_style == true) {
                fomoBadgeStyle = "default-badge";
              }
              tempbadge = true;
              break;
            }
          }
          if (tempbadge) {
            break;
          }
        }
      }
      // Promo Callout
      var collections = product.collections;
      var promo_callout_metaobject = window.theme.promo_callout_metaobject;
      var temppromo = false;
      for (var i = 0; i < promo_callout_metaobject.length; i++) {
        for (var j = 0; j < collections.length; j++) {
          if (collections[j].id == promo_callout_metaobject[i].id) {
            promo_text = promo_callout_metaobject[i].promo_text;
            promo_style = `color:  ${promo_callout_metaobject[i].text_colour};`;
            promo_link = `/collections/${collections[j].handle}`;
            temppromo = true;
            break;
          }
        }
        if (temppromo) {
          break;
        }
      }

      return html`
                  <div class="grid__item medium-down--one-half large-up--one-whole html2">
                    <a href="${productLink}" title="${
        product.title
      }" class="collection__product-link">
                      <div class="product-card product-card--quick" data-pid="${
                        product.id
                      }" data-offer="${offerProperty}" data-sku="${
        product.variants[0].sku
      }">
                        <button
                          data-product="${product.id}"
                          data-product-title="${product.title}"
                          data-variant="${product.variants[0].id}"
                          aria-label="Add ${product.title} to wishlist"
                          class="product-card__wishlist-icon smartwishlist"
                        ></button>
                        <div class="product-card__image">
                          <div class="product-card__image--wrapper">
                              ${
                                product.images.length > 1
                                  ? html`
                                    <div class="image_slider">
                                      <span class="primary-image">
                                        <div class="product-card__image--cover"></div>
                                        <img
                                          src="${product.images[0].src}"
                                          class="component-image__image product-image"
                                          alt="${product.title}"
                                        />
                                      </span>
                                      <span class="secondary-image">
                                        <div class="product-card__image--cover"></div>
                                        <img
                                          src="${product.images[1].src}"
                                          class="component-image__image"
                                          alt="${product.title}"
                                        />
                                      </span>
                                    </div>
                                  `
                                  : html`
                                    <img
                                      src="${product.featured_image.src}"
                                      class="component-image__image"
                                      alt="${product.title}"
                                    />
                                  `
                              }
                          </div>
                          <div class="product-card__actions ${isOnlyInStoreClass}">
                              <${
                                args.templates.addToCartForm
                              } product=${product} />
                              <${
                                args.templates.productObj
                              } product=${product} />
                            </div>
                        </div>
                        ${
                          badge != ""
                            ? html`<div style="${badgeStyles}" class="product-card__badge ${fomoBadgeStyle}" data-product-card-badge="${product.id}" data-badgestr="${badge}">${badge}</div><div class="quickviewBadges" style="display:none;">${quickviewBadgeHtml}</div>`
                            : ""
                        }
                        <div class="product-card__info">
                          <div class="product-card__details">
                            <div class="product-card__text">
                              <div data-oke-reviews-product-listing-rating=""></div>
                              ${
                                promo_text != ""
                                  ? html`<a href="${promo_link}" style="${promo_style}" class="promo_callout" >
                                  <svg class="plp-promo-img" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M3.65389 9.52002L2.72989 6.95802C2.61322 7.00469 2.30709 7.10922 1.73589 7.32202C1.0079 7.61602 1.03359 8.13402 1.06389 8.28802C1.1059 8.66602 1.4979 9.59059 1.67989 9.75802C1.92337 9.98202 2.45922 9.94002 2.67389 9.87002L3.65389 9.52002Z" fill="#FF8557"/>
                                    <path d="M4.0879 9.35202L3.1639 6.79002C4.4855 6.29722 5.92657 4.87669 6.4819 4.22802C6.94857 5.52535 7.9631 8.33282 8.2879 9.18402C6.5855 8.87042 4.77857 9.16535 4.0879 9.35202Z" fill="#FF8557"/>
                                    <path d="M4.3679 9.73002L3.0799 10.192C3.4719 10.57 4.3063 11.3792 4.5079 11.592C4.7179 11.858 4.9979 11.886 5.1799 11.774C5.3927 11.6172 5.34324 11.3634 5.2919 11.256L4.3679 9.73002Z" fill="#FF8557"/>
                                    <path d="M7.0839 3.24802C6.7591 3.36002 6.7619 3.68669 6.8039 3.83602C7.42924 5.54869 8.7023 9.04122 8.7919 9.31002C8.8899 9.52002 9.1979 9.63202 9.4079 9.53402C9.6543 9.42202 9.6879 9.15135 9.6739 9.03002C9.06724 7.36869 7.8147 3.93962 7.6579 3.51402C7.5739 3.30402 7.3219 3.16402 7.0839 3.24802Z" fill="#FF8557"/>
                                    <path d="M11.0422 2.24694C11.1472 2.02294 11.0492 1.74994 10.8322 1.64494C10.6152 1.53994 10.3352 1.64494 10.2302 1.86194L9.64217 3.09394C9.53717 3.31794 9.63517 3.58394 9.85217 3.69594C10.0692 3.80794 10.3492 3.70994 10.4542 3.48594L11.0422 2.25394V2.24694Z" fill="#FF8557"/>
                                    <path d="M11.4761 4.613C11.2451 4.697 11.1261 4.95599 11.2031 5.18699C11.2801 5.41799 11.5461 5.544 11.7771 5.46L13.0441 5.005C13.2751 4.928 13.4011 4.66199 13.3171 4.43099C13.2331 4.20699 12.9741 4.08099 12.7431 4.15799L11.4691 4.60599L11.4761 4.613Z" fill="#FF8557"/>
                                    <path d="M12.5401 8.38602C12.7641 8.49102 13.0371 8.39302 13.1421 8.17602C13.2471 7.95902 13.1421 7.67902 12.9251 7.57402L11.6931 6.98602C11.4691 6.88102 11.1961 6.97202 11.0911 7.19602C10.9861 7.42002 11.0841 7.69302 11.3011 7.79802L12.5331 8.38602H12.5401Z" fill="#FF8557"/>
                                  </svg>
                                  <svg class="quickview-promo-img" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M0.912008 10.752C1.28001 11.776 2.00801 12.2 3.00001 11.984L4.68001 13.696C5.11201 14.136 5.53601 14.272 6.03201 14.096C6.67201 13.864 6.96801 13.232 6.56801 12.552L5.73601 11.152C6.97601 10.952 8.30401 10.952 9.60801 11.176C9.92001 11.568 10.416 11.704 10.944 11.52C11.608 11.28 11.896 10.648 11.656 9.98397L9.40001 3.79197C9.16001 3.12797 8.52801 2.83197 7.86401 3.07197C7.32801 3.26397 7.03201 3.71997 7.06401 4.23197C6.07201 5.43997 4.63201 6.52797 3.38401 7.13597L1.88801 7.67997C0.688008 8.11197 0.272008 8.97597 0.688008 10.136L0.912008 10.744V10.752ZM10.176 10.528L7.92001 4.33597C7.84801 4.12797 7.93601 3.93597 8.14401 3.86397C8.35201 3.79197 8.54401 3.87997 8.61601 4.08797L10.872 10.28C10.944 10.488 10.856 10.68 10.656 10.752C10.456 10.824 10.256 10.736 10.184 10.528H10.176ZM4.76001 10.52L3.79201 7.85597C5.16801 7.15997 6.38401 6.25597 7.33601 5.14397L9.21601 10.32C7.74401 10.072 6.24801 10.168 4.75201 10.52H4.76001ZM3.12801 11.088C2.36801 11.368 1.96001 11.192 1.69601 10.472L1.47201 9.86397C1.20801 9.14397 1.40801 8.75197 2.17601 8.47197L3.02401 8.16797L3.97601 10.792L3.12801 11.096V11.088ZM5.33601 13.216L3.82401 11.72L4.88801 11.336C4.88801 11.336 4.92001 11.336 4.93601 11.32L5.89601 12.912C6.02401 13.112 5.94401 13.296 5.76001 13.368C5.59201 13.424 5.48801 13.368 5.33601 13.216Z" fill="#333333"/>
                                    <path d="M12.832 2.56805C12.952 2.31205 12.84 2.00005 12.592 1.88005C12.344 1.76005 12.024 1.88005 11.904 2.12805L11.232 3.53605C11.112 3.79205 11.224 4.09605 11.472 4.22405C11.72 4.35205 12.04 4.24005 12.16 3.98405L12.832 2.57605V2.56805Z" fill="#333333"/>
                                    <path d="M13.328 5.27199C13.064 5.36799 12.928 5.66399 13.016 5.92799C13.104 6.19199 13.408 6.33599 13.672 6.23999L15.12 5.71999C15.384 5.63199 15.528 5.32799 15.432 5.06399C15.336 4.80799 15.04 4.66399 14.776 4.75199L13.32 5.26399L13.328 5.27199Z" fill="#333333"/>
                                    <path d="M14.544 9.58402C14.8 9.70402 15.112 9.59202 15.232 9.34402C15.352 9.09602 15.232 8.77602 14.984 8.65602L13.576 7.98402C13.32 7.86402 13.008 7.96802 12.888 8.22402C12.768 8.48002 12.88 8.79202 13.128 8.91202L14.536 9.58402H14.544Z" fill="#333333"/>
                                  </svg>
                                  <span>${promo_text}</span>
                                  </div>`
                                  : ""
                              }
                              <h4 class="product-card__title taglays">
                                <span>${product.title}</span>
                              </h4>
                              <div class="product-card__price product-card--flex">
                                ${
                                  helpers.isStorefrontAPICallPending()
                                    ? html`
                                      <span class="skeleton-box"></span>
                                    `
                                    : html`
                                      <span class=${`product-prices ${
                                        helpers.isProductOnSale(
                                          compareAtPrice,
                                          price
                                        )
                                          ? " discounted"
                                          : " full-price"
                                      }`}>
                                        
                                         ${
                                           compareAtPrice === null
                                             ? html`
                                            <span
                                              class="product-price-regular"
                                               dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                     price
                                                   ),
                                               }}
                                              />`
                                             : html`
                                             <span
                                              class="product-price-regular"
                                               dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                     compareAtPrice
                                                   ),
                                               }}
                                              />`
                                         }
                                         ${
                                           helpers.isProductOnSale(
                                             compareAtPrice,
                                             price
                                           )
                                             ? html`
                                            <span
                                              class="sale-price-text-color product-price-discounted"
                                              dangerouslySetInnerHTML=${{
                                                __html:
                                                  helpers.formatCurrency(price),
                                              }}
                                              />
                                            `
                                             : ""
                                         }
                                      </span>
                                    `
                                } ${
        helpers.isProductOnSale(compareAtPrice, price)
          ? html`
                                <span class="product-per-off ${
                                  window.theme.tagalysShowPerOffMobile
                                    ? "show-per-off-mobile"
                                    : ""
                                }${
              window.theme.tagalysShowPerOffDesktop
                ? " show-per-off-desktop"
                : ""
            }">
                                  (${Math.round(
                                    ((compareAtPrice - price) * 100) /
                                      compareAtPrice
                                  )}%)
                                </span>
                              `
          : ""
      }

                              </div>
                            <${
                              args.templates.productReviews
                            } product=${product} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  `;
    },
  },
  filters: {
    options: {
      collapsible: true,
      includeSortOptionsInFilters: false,
      autoCollapse: true,
      showAppliedFilters: true,
      showClearAllFilters: true,
      showClearActionForIndividualFilters: true,
      showMatchingProductsCount: true,
      defaultExpandedFilters: [],
      expandTopNFiltersByDefault: 1,
      showFiltersInDrawer: () => {
        return window.innerWidth <= 768;
      },
    },
    render: function (html, args) {
      var props = args.props;
      var labels = args.labels;
      var helpers = props.helpers;

      var filters = helpers.getFilters();
      var appliedFilters = helpers.getAppliedFilters(true);
      var showClearAllFiltersAction =
        props.showClearAllFilters && appliedFilters.length;
      var classes = ["filters"];
      if (props.collapsible) {
        classes.push("collapsible");
      }

      var className = classes.join(" ");
      return html`
              
              <div class="collection-filters-block">
                <${args.templates.filtersHeader} />

                ${
                  props.includeSortOptionsInFilters === "top"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
                ${filters.map(
                  (filter) =>
                    html`
                      <${args.templates.filter} filter=${filter} />
                    `
                )}
                ${
                  props.includeSortOptionsInFilters === true ||
                  props.includeSortOptionsInFilters === "bottom"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
              </div>
            `;
    },
    callbacks: {
      afterEveryRender: function (helpers) {
        const searchInputs = document.querySelectorAll(".search__input");
        if (!searchInputs || searchInputs.length === 0) {
          return;
        }

        searchInputs.forEach((inputEL) => {
          inputEL.addEventListener("focus", function () {
            const filtersDrawer = document.querySelector(
              ".show-filters-in-drawer"
            );
            if (filtersDrawer && helpers.isFilterDrawerOpen()) {
              helpers.closeFilterDrawer();
            }
          });
        });

        var product_card_show_variants = document.querySelectorAll(
          ".product-card__variants--show"
        );
        product_card_show_variants.forEach((variant) => {
          variant.classList.remove("product-card__variants--show");
        });

        setTimeout(function () {
          var relatedProductCards = document.querySelectorAll(".product-card");
          if (relatedProductCards && relatedProductCards.length) {
            relatedProductCards.forEach((productCardElement) => {
              new window.theme.ProductCard(productCardElement, "tagalys");
              const pid = productCardElement.dataset.pid;
              const selector = `[data-product-card-badge="${pid}"]`;
              const productCardBadge = productCardElement.querySelector(selector);
              if (productCardBadge) {
                theme.switchBadgeCurrency.updateProductCardBadges(selector);
              }
            });
          }
          if ("EU" === window.theme.store && promo_multibuy == 0) {
            promo_multibuy = 1;
            var multibuyHeaderEl = ".promo_callout span";
            theme.CurrencySwitcher.switchCurrency(multibuyHeaderEl);
          }
        }, 2000);
        setTimeout(function () {
          var filterBarElement = document.querySelector(".collection__tabs");
          var filterWrapperElement = document.querySelector(".filter-wrapper");
          var headerElement = document.querySelector("#shopify-section-header");
          var headerElementHeight = headerElement
            ? headerElement.getBoundingClientRect().height
            : 0;
          var headerHeight = headerElementHeight - 2;
          if (
            filterBarElement &&
            window.innerWidth < theme.settings.grid_medium
          ) {
            this.filterBar = stickybits(".plp-header", {
              stickyBitStickyOffset: headerHeight,
              useStickyClasses: true,
              useGetBoundingClientRect: true,
            });
          }

          if (
            filterWrapperElement &&
            window.innerWidth > theme.settings.grid_medium
          ) {
            this.filterWrapper = stickybits(".filter-wrapper-old", {
              stickyBitStickyOffset: headerHeight,
              useStickyClasses: true,
              useGetBoundingClientRect: true,
            });
          }
        }, 1000);

        var _ProductCards = document.querySelectorAll(".product-card");
        if (_ProductCards && _ProductCards.length) {
          _ProductCards.forEach((productCardElement) => {
            const pid = productCardElement.dataset.pid;
            const selector = `[data-product-card-badge="${pid}"]`;
            const productCardBadge = productCardElement.querySelector(selector);
            if (productCardBadge) {
              theme.switchBadgeCurrency.updateProductCardBadges(selector);
            }
          });
        }
      },
    },
  },
  filtersHeader: {
    render: function (html, args) {
      var props = args.props;
      var labels = args.labels;
      return html``;
    },
  },
  appliedFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var appliedFilters = helpers.getAppliedFilters(true);
      if (!appliedFilters.length) {
        return html``;
      }

      return html`
              <ul class="applied-filters unstyled-list">
                ${appliedFilters.map((appliedFilter) => {
                  if (appliedFilter.type === "range") {
                    return html`
                      <li onClick=${() => {
                        helpers.clearFilter(appliedFilter.id);
                        removeFilterDataLayerEvent(props, appliedFilter.id);
                      }} class="applied-filter">
                          <span class="filter__label applied-filter-label" 
                        dangerouslySetInnerHTML=${{
                          __html:
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_min,
                            appliedFilter.currency
                          )+'<span class="price-applied-space">-</span>'+
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_max,
                            appliedFilter.currency
                          ),
                        }} />
                        <span class="filter__label applied-filter-action-clear">
                          <${args.templates.closeIcon} />
                        </span>
                      </li>
                    `;
                  }
                  return appliedFilter.items.map((filterItem) => {
                    const filterItemName = appliedFilter.id == "size" ? filterItem.label.toUpperCase() : filterItem.label.toLowerCase();
                    return html`
                      <li
                        class="display-flex applied-filter"
                        onClick=${() => {
                          helpers.clearFilter(appliedFilter.id, filterItem.id);
                          removeFilterDataLayerEvent(
                            props,
                            appliedFilter.id,
                            filterItem
                          );
                        }}
                      >
                        <span class="filter__label applied-filter-label">
                          ${filterItemName}
                        </span>
                        <span class="filter__label applied-filter-action-clear">
                          <${args.templates.closeIcon} />
                        </span>
                      </li>
                    `;
                  });
                })}
                  <li class="applied-filter filter__label clear-all-filters" onclick=${() => {
                    helpers.clearAllFilters();
                    clearAllFilterDataLayerEvent(props);
                  }}>
                     <span class="filter__label applied-filter-label">Clear All</span>
                  </li>
              </ul>
            `;
    },
  },
  closeIcon: {
    render: function (html, args) {
      return html`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Exclude" fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM8.39406 3.76859C8.59945 3.98896 8.58731 4.33411 8.36694 4.5395L6.77087 6.02708L8.25845 7.62315C8.46384 7.84352 8.45169 8.18867 8.23132 8.39406C8.01095 8.59945 7.6658 8.58731 7.46041 8.36694L5.97283 6.77087L4.37676 8.25845C4.15639 8.46384 3.81124 8.45169 3.60585 8.23132C3.40046 8.01095 3.4126 7.6658 3.63297 7.46041L5.22904 5.97283L3.74146 4.37676C3.53607 4.15639 3.54822 3.81124 3.76859 3.60585C3.98896 3.40046 4.33411 3.4126 4.5395 3.63297L6.02708 5.22904L7.62315 3.74146C7.84352 3.53607 8.18867 3.54822 8.39406 3.76859Z" fill="#333333"/></svg>`;
    },
  },
  filter: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var classes = ["collection__filter", "filter"];
      var isCollapseOpen = false;
      if (Firstfilter == 0) {
        Firstfilter = props.filter.id;
      }
      if (props.collapsible) {
        isCollapseOpen = helpers.isCollapsibleFilterExpanded(props.filter.id);
        if (isCollapseOpen) {
          classes.push("expanded");
        } else {
          classes.push("collapsed");
        }
      }
      var className = classes.join(" ");
      return html`
              <div class=${className} data-filter-id=${props.filter.id}>
                <${args.templates.filterHeader} filterHeading=${props.filter.label} filterId=${props.filter.id} />
                <${args.templates.filterItems} filter=${props.filter} />
              </div>
            `;
    },
  },
  filterHeader: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var filterOptions = helpers.getTemplateOptions("filters");
      var showClearActionForIndividualFilters =
        filterOptions.showClearActionForIndividualFilters &&
        helpers.isFilterApplied(props.filterId);
      var toggleCollapsibleFilter = () => {
        helpers.toggleCollapsibleFilter(props.filterId);
      };
      var clearFilter = (event) => {
        event.stopPropagation();
        helpers.clearFilter(props.filterId);
        removeFilterDataLayerEvent(props, props.filterId);
      };
      return html`
              <div
                onClick=${
                  filterOptions.collapsible
                    ? toggleCollapsibleFilter
                    : undefined
                }
                class="filter__label filter-header"
              >
                <h3 class="filter-heading filter__button">
                  ${props.filterHeading}
                </h3>
                <div class="filter-actions">
                  ${
                    showClearActionForIndividualFilters
                      ? html`
                        <div onClick=${clearFilter} class="filter-action-clear">
                          ${labels.filters.clearIndividualFilter}
                        </div>
                      `
                      : ""
                  }
                  <span class="filter-action-toggle-collapse">
                    ${
                      filterOptions.collapsible
                        ? html`
                          <${args.templates.downArrow} />
                        `
                        : ""
                    }
                  </span>
                </div>
              </div>
            `;
    },
  },
  filterItems: {
    render: function (html, args) {
      var props = args.props;
      if (props.filter.type === "checkbox") {
        return html`
                <div class="filter__list filter-body filter-body-checkboxes ${props.filter.id}">
                  <${args.templates.filterCheckBoxes} filterId=${props.filter.id} filterItems=${props.filter.items} />
                </div>
              `;
      }
      return html`
              <div class="filter__list filter-body filter-body-range">
                <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
              </div>
            `;
    },
  },
  filterCheckBoxes: {
    render: function (html, args) {
      var props = args.props;
      let showLessHtml = "";
      let show_more_count = props.filterItems.length;
      return html`
              <ul class="filter-checkboxes">
                ${props.filterItems.map((filterItem, index) => {
                  let classname = "";
                  let showMoreHtml = "";

                  if (window.innerWidth < 768 && props.filterId == "colour") {
                    if (index == 18) {
                      show_more_count = show_more_count - 18;
                      classname = "expand";
                      showMoreHtml = html`<li class="show_more  show_more_color">Show ${show_more_count} More</li>`;
                      showLessHtml = html`<li class="show_less show_less_color" style="display:none;">Show Less</li>`;
                    }
                  } else if (index == 5) {
                      show_more_count = show_more_count - 5;
                      classname = "expand";
                      showMoreHtml = html`<li class="show_more show_more_click">Show ${show_more_count} More</li>`;
                      showLessHtml = html`<li class="show_less show_less_click" style="display:none;">Show Less</li>`;
                  }
                  
                  return html`
                 ${showMoreHtml}
                  <${args.templates.checkboxFilterItem}
                    filterId=${props.filterId}
                    filterItem=${filterItem}
                    index=${index}
                    class=${classname}
                  >
                  ${
                    filterItem.selected && filterItem.items
                      ? html`
                          <${args.templates.filterCheckBoxes}
                            filterId=${props.filterId}
                            filterItems=${filterItem.items}
                          />
                        `
                      : ""
                  }
                </${args.templates.checkboxFilterItem}>
              `;
                })}
                ${showLessHtml}
              </ul>
            `;
    },
  },
  checkboxFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      const onFilterClick = (event) => {
        event.stopPropagation();
        if (props.filterItem.selected) {
          helpers.clearFilter(props.filterId, props.filterItem.id);
          removeFilterDataLayerEvent(props, props.filterId, props.filterItem);
        } else {
          helpers.applyFilter(props.filterId, props.filterItem.id);
          applyFilterDataLayerEvent(props);
        }
      };
      var icon = "";
      var code = "#1A1A1A";
      if (props.filterId == "colour") {
        var filterName = String(props.filterItem.label.trim()).toLowerCase();
        if (window.plp_vars.coloursMeta[filterName]) {
          if (window.plp_vars.coloursMeta[filterName].icon) {
            icon = window.plp_vars.coloursMeta[filterName].icon;
          } else if (window.plp_vars.coloursMeta[filterName].code) {
            code = window.plp_vars.coloursMeta[filterName].code;
          }
        }
      }
      var colour_icon = html`<span></span>`;
      if (props.filterId == "colour") {
        if (icon != "") {
          colour_icon = html`<span class="colour-icon"><img src="${icon}" /></span>`;
        } else {
          colour_icon = html`<span class="colour-icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Colour">
                            <circle  cx="8" cy="8" r="8" fill="${code}"></circle>
                            </g>
                            </svg></span>`;
        }
      }

      return html`
              <li class="filter-item ${props.filterId}" data-filter-item-id=${
        props.filterItem.id
      } onClick=${onFilterClick}>
                <div class="filter__type filter-checkbox-and-label ${props.filterItem.label.toLowerCase()}">
                  ${colour_icon}
                  <input class="checkbox" checked=${
                    props.filterItem.selected
                  } type="checkbox" aria-label="Filter Item" />
                  <span class="filter-item-label-and-count">
                    <span class="filter-item-label">${props.filterItem.label.toLowerCase()}</span>
                    ${
                      props.showMatchingProductsCount
                        ? html`
                          <span class="filter-item-count">(${props.filterItem.count})</span>
                        `
                        : ""
                    }
                  </span>
                </div>
                ${props.children}
              </li>
            `;
    },
  },
  rangeSliderFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var priceLabel = "Any";

      if (
        props.sliderInputValues[0] > props.filter.min &&
        props.sliderInputValues[1] < props.filter.max
      ) {
        priceLabel =
          "Between " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[0],
            props.filter.currency
          ) +
          " - " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[1],
            props.filter.currency
          );
      } else if (props.sliderInputValues[0] > props.filter.min) {
        priceLabel =
          "Above " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[0],
            props.filter.currency
          );
      } else if (props.sliderInputValues[1] < props.filter.max) {
        priceLabel =
          "Below " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[1],
            props.filter.currency
          );
      }
      var minPriceValue = window.Currency.formatMoney(
        props.sliderInputValues[0] * 100,
        window.Currency.moneyFormats[window.Shopify.currency.active]
          .money_format
      );
      var maxPriceValue = window.Currency.formatMoney(
        props.sliderInputValues[1] * 100,
        window.Currency.moneyFormats[window.Shopify.currency.active]
          .money_format
      );
      var priceValueLeft = "0%";
      if (props.sliderInputValues[0] > props.filter.min) {
        priceValueLeft =
          ((props.sliderInputValues[0] - props.filter.min) / props.filter.max) *
          100;
        priceValueLeft += "%";
      }
      var priceValueRight = "0%";
      if (props.sliderInputValues[1] < props.filter.max) {
        // eslint-disable-next-line no-mixed-operators
        priceValueRight =
          (100 - props.sliderInputValues[1] / props.filter.max) * 100;
        priceValueRight += "%";
      }

      var priceValueLeftClass = "";
      var priceValueRightClass = "";

      if (document.querySelector(".noUi-handle-lower.noUi-active")) {
        priceValueLeftClass = "drag";
      }
      if (document.querySelector(".noUi-handle-upper.noUi-active")) {
        priceValueRightClass = "drag";
      }

      return html`
              <div class="range-slider filter-item">
                <span class="max-range-info" style="display:none;">${priceLabel}</span>
                <div class="price-range-value" style="display:none;">
                  <span class="price-range__label--min-price ${priceValueLeftClass}" style="left: ${priceValueLeft};">
                    ${minPriceValue}
                  </span>
                  <span class="price-range__label--max-price ${priceValueRightClass}" style="right: ${priceValueRight};">
                    ${maxPriceValue}
                  </span>
                </div>
                
                <div></div>
                <div class="price-range__input-group">
                  <div class="min-price">
                  <span class="min-label">Min</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">${
                      window.theme.currentCurrencySymbol
                    }</span>
                    <input
                      id="priceRangeMin"
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=0
                      value=${props.sliderInputValues[0]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMinChange}
                      onfocus=${(this.value = "")}
                      aria-label="Price Range Input"
                    />
                    <label style="display:none;" for="priceRangeMin">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.min,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  </div>
                  <span class="to" style="display:none;">${
                    labels.filters.rangeFilterValueSeparator
                  }</span>
                   <div class="min-price">
                  <span class="min-label">Max</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">${
                      window.theme.currentCurrencySymbol
                    }</span>
                    <input
                      id="priceRangeMax"
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=0
                      value=${props.sliderInputValues[1]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMaxChange}
                    />
                    <label style="display:none;" for="priceRangeMax">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.max,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  </div>
                </div>
                <div ref=${props.sliderRef} />
              </div>
            `;
    },
  },
  sortOptionInFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;

      var filterOptions = helpers.getTemplateOptions("filters");
      var appliedSortOption = helpers.getAppliedSortOption();
      var sortOptions = helpers.getSortOptions();

      let classes = ["filter"];
      let isCollapseOpen = false;
      if (filterOptions.collapsible) {
        isCollapseOpen = helpers.isCollapsibleFilterExpanded("sort_options");
        if (isCollapseOpen) {
          classes.push("expanded");
        } else {
          classes.push("collapsed");
        }
      }
      var className = classes.join(" ");

      return html`
              <div data-filter-id="sort_options" class=${className}>
                <${args.templates.filterHeader} filterHeading=${
        labels.sortOptions.sortBy
      } filterId=${"sort_options"} />
                <div class="filter-body filter-body-checkboxes">
                  <ul class="filter-checkboxes">
                    ${sortOptions.map((sortOption) => {
                      const checked = sortOption.id === appliedSortOption.id;
                      return html`
                        <li
                          class="filter-item"
                          data-filter-item-id=${sortOption.id}
                          onClick=${() => {
                            helpers.applySortOption(sortOption.id);
                            clickSortOptionDataLayerEvent(helpers);
                          }}
                        >
                          <span class="filter-checkbox-and-label">
                            <input class="checkbox" checked=${checked} type="checkbox" />
                            <span class="filter-item-label-and-count">
                              <span class="filter-item-label">${
                                sortOption.label
                              }</span>
                            </span>
                          </span>
                        </li>
                      `;
                    })}
                  </ul>
                </div>
              </div>
            `;
    },
  },
  downArrow: {
    // eslint-disable-next-line no-unused-vars
    render: function (html, args) {
      return html`
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                viewBox="0 0 10 4"
                class="down-arrow icon icon--wide icon-chevron-down"
              >
                <path fill="none" stroke="#555" d="M9 0L5 4 1 0"></path>
              </svg>
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                viewBox="0 0 13 6"
                class="icon icon--wide icon-chevron-up-2"
              >
                <path fill="none" stroke="#333" d="M1 6l5.5-6L12 6"></path>
              </svg>
            `;
    },
  },
  addToCartForm: {
    render: function (html, args) {
      var product = args.props.product;
      var variants = product.variants;
      var isOnlyInStore = false;
      var tags = product.tags;
      if (tags.length) {
        tags.forEach(function (tag) {
          if (tag === "in-store") {
            isOnlyInStore = true;
          }
        });
      }

      return html`
              <${args.templates.productsQuickview} product=${product} />
             
              <form action="${
                window.plp_vars.cart_add_url
              }" method="post" enctype="multipart/form-data" class="form">
                <input type="hidden" name="quantity" value="1" />
                <${args.templates.variantSelect} product=${product} />
                <${args.templates.variantOption} product=${product} />
                ${
                  variants.length > 1
                    ? html`
                      <button class="product__add--show-variants" type="button" aria-label="Add to bag">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5"/>
                          <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5"/>
                          <g clip-path="url(#clip0_750_7208)">
                          <path d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z" fill="#333333"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_750_7208">
                          <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)"/>
                          </clipPath>
                          </defs>
                        </svg>
                      </button>
                      <button
                        type="button"
                        class="product__add--mobile product__add--show-variants"
                        aria-label="Add to bag"
                      >
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5"/>
                          <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5"/>
                          <g clip-path="url(#clip0_750_7208)">
                          <path d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z" fill="#333333"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_750_7208">
                          <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)"/>
                          </clipPath>
                          </defs>
                        </svg>
                      </button>
                    `
                    : html`
                      <button
                        class="product__add"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="Add to bag"
                      >
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5"/>
                        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5"/>
                        <g clip-path="url(#clip0_750_7208)">
                        <path d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z" fill="#333333"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_750_7208">
                        <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)"/>
                        </clipPath>
                        </defs>
                      </svg>
                      </button>
                      <button
                        class="product__add--mobile"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="Add to bag"
                      >
                        <svg class="icon icon-shopping-bag" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <title>Open shopping bag</title>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 20.6644H8C5.239 20.6644 3 18.4652 3 15.7534V8.51857C3 7.9764 3.448 7.53638 4 7.53638H20C20.552 7.53638 21 7.9764 21 8.51857V15.7534C21 18.4652 18.761 20.6644 16 20.6644Z" stroke="#111111" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path>
                          <path d="M16 10.8424V4.94925C16 3.86393 15.105 2.98486 14 2.98486H10C8.895 2.98486 8 3.86393 8 4.94925V10.8424" stroke="#111111" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path>
                        </svg>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-checkmark"
                          viewBox="0 0 130.2 130.2"
                        >
                          <path
                            class="path"
                            fill="none"
                            stroke="#fff"
                            stroke-width="13"
                            stroke-linecap="square"
                            stroke-miterlimit="10"
                            d="M100.2 40.2L51.5 88.8 29.8 67.5"
                          ></path>
                        </svg>
                      </button>
                    `
                }
              </form>
            `;
    },
  },
  variantOption: {
    render: function (html, args) {
      var product = args.props.product;
      var variants = product.variants;
      return html`
          <div class="product-card__variant-picker product-card__variant-picker--with-options">
            <span class="variant-picker__message visually-hidden" tabindex="-1">
              Please select an option below to add to cart.</span>
            <div role="list" class="product-card__variants">
              ${variants.map((variant) => {
                if (variant.available) {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button class="btn btn--text add-product-variant" data-variant-id="${variant.id}">
                        ${variant.title}
                      </button>
                    </div>
                  `;
                } else {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button
                        class="btn btn--text add-product-variant"
                        disabled="disabled"
                        data-variant-id="${variant.id}"
                      >
                        ${variant.title}
                      </button>
                    </div>
                  `;
                }
              })}
              <div role="listitem" class="product-card__variant-container">
                <button
                        type="button"
                        class="close-show-variants"
                        aria-label="Close the variants"
                      >
                  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="close" d="M1.6129 0.234883C1.29972 -0.0782944 0.791957 -0.0782944 0.47878 0.234883C0.165602 0.548061 0.165602 1.05582 0.47878 1.369L5.10978 6L0.478828 10.631C0.16565 10.9441 0.16565 11.4519 0.478828 11.7651C0.792005 12.0782 1.29977 12.0782 1.61294 11.7651L6.2439 7.13412L10.8748 11.7651C11.188 12.0782 11.6958 12.0782 12.009 11.7651C12.3221 11.4519 12.3221 10.9441 12.009 10.631L7.37801 6L12.009 1.369C12.3222 1.05582 12.3222 0.548061 12.009 0.234883C11.6958 -0.0782944 11.1881 -0.0782944 10.8749 0.234883L6.2439 4.86588L1.6129 0.234883Z" fill="#999999"/>
                  </svg>
                </button>
              </div>
            </div>
            <div role="list" class="product-card__mobile-variants">
              ${variants.map((variant) => {
                if (variant.available) {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button class="btn btn--text add-product-variant" data-variant-id="${variant.id}">
                        ${variant.title}
                      </button>
                    </div>
                    <div role="listitem">
                      <button class="product-card__variant add-product-variant" data-variant-id="${variant.id}">
                        <span class="product-card__variant-text">${variant.title}</span>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-checkmark"
                          viewBox="0 0 130.2 130.2"
                        >
                          <path
                            class="path"
                            fill="none"
                            stroke="#fff"
                            stroke-width="13"
                            stroke-linecap="square"
                            stroke-miterlimit="10"
                            d="M100.2 40.2L51.5 88.8 29.8 67.5"
                          />
                        </svg>
                      </button>
                    </div>
                  `;
                } else {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button
                        class="btn btn--text add-product-variant"
                        disabled="disabled"
                        data-variant-id="${variant.id}"
                      >
                        ${variant.title}
                      </button>
                    </div>
                    <div role="listitem">
                      <button class="product-card__variant add-product-variant" data-variant-id="${variant.id}">
                        <span class="product-card__variant-text">${variant.title}</span>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-checkmark"
                          viewBox="0 0 130.2 130.2"
                        >
                          <path
                            class="path"
                            fill="none"
                            stroke="#fff"
                            stroke-width="13"
                            stroke-linecap="square"
                            stroke-miterlimit="10"
                            d="M100.2 40.2L51.5 88.8 29.8 67.5"
                          />
                        </svg>
                      </button>
                    </div>
                  `;
                }
              })}
            </div>
          </div>
        `;
    },
  },
  variantSelect: {
    render: function (html, args) {
      var product = args.props.product;
      var variants = product.variants;
      return html`
              <select name="id" class="no-js" aria-label="Select variant" data-product-select>
                ${variants.map((variant, i) => {
                  return html`
                    <option ${
                      i === 0 ? 'selected="selected"' : ""
                    } data-i-${i} value="${variant.id}"
                      >${variant.title}</option
                    >
                  `;
                })}
              </select>
            `;
    },
  },
  productObj: {
    // Custom template to render variants
    render: function (html, args) {
      var product = args.props.product;
      return html`
              <div style="display:none;" data-product-json>
                ${JSON.stringify(product)}
              </div>
            `;
    },
  },
  products: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var products = helpers.getProducts();
      viewPLPDataLayerEvent(
        props.helpers,
        ".collection__products .product-card"
      );
      // plp inline ad function to check and render the inline ad base on the position
      // check if the ad is active
      const validOnmiPlpAdArray = removeSamePositionAds.filter((adItem) => isActiveInlineAd(adItem));

      const inlineAdHTML = (inlineAdMetaObjDetails, productItem) => { 
  
  
        return html`
            <div class="grid__item medium-down--one-half large-up--one-whole html2">
              <a href="${inlineAdMetaObjDetails?.link?.url}" title="${inlineAdMetaObjDetails.title}" class="collection__product-link">
                <div class="product-card product-card--quick" >
                  
                  <div class="product-card__image">
                    <div class="product-card__image--wrapper small-down--hide">
                              <img
                                src="${inlineAdMetaObjDetails.desktop_image}"
                                class="component-image__image"
                                alt="${inlineAdMetaObjDetails?.link?.text}"
                              />           
                    </div>
                    <div class="product-card__image--wrapper large-up--hide">
                              <img
                                src="${inlineAdMetaObjDetails.mobile_image}"
                                class="component-image__image"
                                alt="${inlineAdMetaObjDetails?.link?.text}"
                              />           
                    </div>
                    <div class="product-card__actions hide">
                              <${
                                args.templates.addToCartForm
                              } product=${productItem} />
                              <${
                                args.templates.productObj
                              } product=${productItem} />
                            </div>
                    
                  </div>
    
                  <div class="product-card__info">
                    <div class="product-card__details">
                      <div class="product-card__text">
                        <div data-oke-reviews-product-listing-rating=""></div>
                        <h4 class="product-card__title taglays">
                          <span></span>
                        </h4>
                        <div class="product-card__price product-card--flex">
                        
    
                        </div>
                      
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
    `};
    const renderOmniInlineAd = (activeAdArray, inputIndex, productItem) => {
  
      // get the current language when the store is EU and the Weglot is available other wise keep the current language to 'en'
      currentLang = window.theme.store === 'EU' && window.Weglot ? window.Weglot.getCurrentLang() : 'en';
      // when the current language is not 'en' and the hideInlineAdsNonEn is true then return empty string
      const displaybyLang = window.theme.hideInlineAdsNonEn && currentLang !== 'en' ? true : false;
    
      
      if (displaybyLang || !window.theme.collectionTitle || (activeAdArray && activeAdArray.length === 0)) {
        return html``;
      }
    
      // transfer the activeAdArray to use the position as the key and object as the value
      const activeAdObject = activeAdArray.reduce((acc, item) => {
        acc[item.position] = item;
        return acc;
      }, {});
      
      const selectPosition = mappingIndexObj[inputIndex];
      const selecledAd = activeAdObject[selectPosition];
      
      if (activeAdArray.length > 0 && selectPosition && selecledAd) {
        return inlineAdHTML(selecledAd, productItem);
      } else {
        return html``;
      }
    };
    // end of the inline ad rendering function. the function will be used in the html template below
      
      return html`
        ${products.map((product, index) =>
          product.images.length > 0
            ? html`
                ${renderOmniInlineAd(validOnmiPlpAdArray, index, product)}
                <${args.templates.product} key=${index} product=${product} />
              `
            : ""
        )}
      `;
    },
    callbacks: {
      // eslint-disable-next-line no-unused-vars
      afterInitialRender: function (helpers) {
        setTimeout(function () {
          var relatedProductCards = document.querySelectorAll(".product-card");
          if (relatedProductCards && relatedProductCards.length) {
            relatedProductCards.forEach((productCardElement) => {
              new window.theme.ProductCard(productCardElement, "tagalys");
            });
          }
        }, 2000);

        var _ProductCards = document.querySelectorAll(".product-card");
        if (_ProductCards && _ProductCards.length) {
          _ProductCards.forEach((productCardElement) => {
            const pid = productCardElement.dataset.pid;
            const selector = `[data-product-card-badge="${pid}"]`;
              const productCardBadge = productCardElement.querySelector(selector);
              if (productCardBadge) {
                theme.switchBadgeCurrency.updateProductCardBadges(selector);
              }
          });
        }
      },
    },
  },
  sortOptions: {
    render: function (html, args) {
      var props = args.props;
      var labels = args.labels;
      var helpers = props.helpers;
      var sortOptions = helpers.getSortOptions();
      var appliedSortOption = helpers.getAppliedSortOption();

      var applySortOption = (event) => {
        helpers.applySortOption(event.target.value);
        clickSortOptionDataLayerEvent(helpers);
        // plpDataLayerEvents
        theme.PLPDataLayerEvents.setPLPDataLayerEvent({
          event: 'item_list_filter',
          interaction_type: 'Sort',
          list_sort_order: event.target.value
        });
      };

      return html`
              <div class="sort-options-container">
                <select class="sort-options" data-lvtrack-entity="sort" value=${
                  appliedSortOption.id
                } onchange=${applySortOption}>
                  ${sortOptions.map((sortOption) => {
                    return html`
                      <option value=${sortOption.id}>${sortOption.label}</option>
                    `;
                  })}
                </select>
              </div>
            `;
    },
  },
  productsQuickview: {
    render: function (html, args) {
      var product = args.props.product;
      var onClick = function (e) {
        const mutationCallback = (reqState) => {
          console.log(e.target);
          //this.setAttribute("checked", "checked");
          e.checked = true;

          reqState.perPage = parseInt(e.target.value);
          return reqState;
        };
        args.props.helpers.setRequestState(mutationCallback);
      };
      return html`
      <div class="quickview">
        <button class=open-quickview data-product=${product.handle}>                    
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.25" y="0.251465" width="31.5" height="31.4986" rx="15.7493" fill="white" fill-opacity="0.5"/>
          <rect x="0.25" y="0.251465" width="31.5" height="31.4986" rx="15.7493" stroke="#333333" stroke-width="0.5"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8307 13.3455C22.8662 14.4253 23.5724 15.6147 23.9331 16.4919C24.0223 16.7091 24.0223 16.9505 23.9331 17.1677C23.5277 18.1491 22.6521 19.5569 21.355 20.7797C20.0497 21.9864 18.2498 23.0001 16.0041 23.0001C13.7583 23.0001 11.9584 21.9864 10.6532 20.7797C9.34786 19.565 8.48036 18.1491 8.06689 17.1677C7.9777 16.9505 7.9777 16.7091 8.06689 16.4919C8.42022 15.6326 9.11103 14.4795 10.114 13.4143L9.34759 12.7784C9.10163 12.5743 9.06746 12.2107 9.27125 11.9663C9.47504 11.722 9.83963 11.6893 10.0856 11.8934L10.9534 12.6134C11.4637 12.1792 12.0411 11.7798 12.6834 11.4568L12.0808 10.4252C11.9199 10.1499 12.0128 9.79624 12.2881 9.63539C12.5635 9.47454 12.9171 9.56737 13.078 9.84273L13.7615 11.013C14.2023 10.8702 14.6675 10.7654 15.1565 10.7085L15.1565 9.57889C15.1565 9.25999 15.415 9.00146 15.7339 9.00146C16.0528 9.00146 16.3113 9.25999 16.3113 9.57889V10.6659C16.7738 10.6851 17.2166 10.7473 17.6393 10.8448L18.2168 9.84513C18.3763 9.569 18.7295 9.47447 19.0056 9.634C19.2818 9.79352 19.3763 10.1467 19.2168 10.4228L18.7662 11.2028C19.604 11.5444 20.3442 12.0203 20.9821 12.5523L21.7762 11.8934C22.0222 11.6893 22.3868 11.722 22.5906 11.9664C22.7944 12.2108 22.7602 12.5743 22.5142 12.7784L21.8307 13.3455ZM20.4469 19.8144C19.3038 20.8682 17.812 21.6807 16.0041 21.6807C14.1961 21.6807 12.7043 20.8682 11.5612 19.8144C10.491 18.8249 9.75323 17.6584 9.37218 16.8298C9.75323 15.9771 10.491 14.8347 11.5612 13.8452C12.7043 12.7914 14.1961 11.9789 16.0041 11.9789C17.812 11.9789 19.3038 12.7914 20.4469 13.8452C21.5171 14.8347 22.2306 15.9771 22.6359 16.8298C22.2306 17.6584 21.5171 18.8249 20.4469 19.8144ZM16.0035 19.4765C17.4767 19.4765 18.6709 18.2916 18.6709 16.8298C18.6709 15.3681 17.4767 14.1831 16.0035 14.1831C14.5304 14.1831 13.3362 15.3681 13.3362 16.8298C13.3362 18.2916 14.5304 19.4765 16.0035 19.4765Z" fill="#333333"/>
          </svg>
        </button>
      </div>
       `;
    },
  },
  productsPerPage: {
    render: function (html, args) {
      var onClick = function (e) {
        const mutationCallback = (reqState) => {
          console.log(e.target);
          //this.setAttribute("checked", "checked");
          e.checked = true;

          reqState.perPage = parseInt(e.target.value);
          return reqState;
        };
        args.props.helpers.setRequestState(mutationCallback);
      };
      var onChange = function (e) {
        const mutationCallback = (reqState) => {
          reqState.perPage = parseInt(e.target.value);
          return reqState;
        };
        args.props.helpers.setRequestState(mutationCallback);
      };
      var defaultChecked = html`<input type="radio"  name="product-per-page-mobile" value="60" onchange=${onClick} />`;
      if (args.props.helpers.getRequestState().perPage == 60) {
        defaultChecked = html`<input type="radio"  checked name="product-per-page-mobile" value="60" onchange=${onClick} />`;
      }
      return html`
      <select class="product-per-page" name="per-page" onchange=${onChange}>
                                 <option value="${window.plp_vars.plp_limit}">Products Per Page</option>
                                 <option value="24">24</option>
                                 <option value="36">36</option>
                                 <option value="48">48</option>
                                 <option value="60">60</option>
                                 <option value="72">72</option>
                                 <option value="84">84</option>
                              </select>
   <div class="product-per-page-mobile">                           
        <div  class="collection__filter filter collapsed">
	<div class="filter__label filter-header ">
		<h3 class="filter-heading filter__button">Products Per Page</h3>
			<div class="filter-actions">
				<span class="filter-action-toggle-collapse">
					<svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 4" class="down-arrow icon icon--wide icon-chevron-down"><path fill="none" stroke="#555" d="M9 0L5 4 1 0"></path></svg><svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 13 6" class="icon icon--wide icon-chevron-up-2"><path fill="none" stroke="#333" d="M1 6l5.5-6L12 6"></path></svg>
				</span>
			</div>
	</div>
	<div class="filter-body filter-body-range filter__list">
		<div class="range-slider filter-item">
			
				 <div class="radio-inline">
                       <label>
    					  <input type="radio" name="product-per-page-mobile" value="24" onchange=${onClick} />
    					  24
                     </label>
				  </div>
				  <div class="radio-inline">
                      <label>
    					  <input type="radio"  name="product-per-page-mobile" value="36" onchange=${onClick} />
    					  36
                     </label>
				  </div>
				  <div class="radio-inline ">
					  <label>
                         ${defaultChecked}
    					  60
                       </label>
				  </div>
				   <div class="radio-inline">
					  <label>
                         <input type="radio"  name="product-per-page-mobile" value="72"  onchange=${onClick} />
    					  72
                       </label>
				  </div>
				  <div class="radio-inline">
                      <label for="per-page-80">
    					  <input type="radio" name="product-per-page-mobile" value="84" onchange=${onClick} />
    					  84
                       </label>
				  </div>
			</div>             
		</div>
	</div>
</div>    
`;
    },
  },
  productListHeader: {
    render: function (html, args) {
      return html`
              <${args.templates.infoAndActions} />
            `;
    },
  },
  noResults: {
    options: "",
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      return html`
              <div class="no-results page-width-wide">
                <div class="no-results-heading tg-no-result-heading">
                  ${labels.searchResults.noResultsHeading.heading}
                  <b>"${helpers.getQuery()}"</b>
                  <span class="tg-no-result-subheading">
                    ${labels.searchResults.noResultsHeading.subHeading}
                  </span>
                </div>
                <div class="tg-no-result-products-wrapper">
                  <div class="tg-no-result-products-widget-wrapper">
                    <${args.templates.noResultsWidgets} />
                  </div>
                </div>
              </div>
            `;
    },
  },
  paginationLinks: {
    options: {
      showNumberedPageLinks: true,
      numberedPageLinksWindowSize: 3,
      showPreviousPageLink: true,
      showFirstPageLink: true,
      showNextPageLink: true,
      scrollTop: true,
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var pagesToDisplay = helpers.getPagesToDisplay(
        props.numberedPageLinksWindowSize
      );
      if (pagesToDisplay.length <= 1) {
        return;
      }
      var currentPage = helpers.getCurrentPage();
      var hasPreviousPage = helpers.hasPreviousPage();
      var hasNextPage = helpers.hasNextPage();

      var goToFirstPage = () => {
        helpers.goToPage(1);
      };

      return html`
          <ul class="ais-pagination">
            ${
              props.showFirstPageLink
                ? html`
                  <li class="ais-pagination__item ais-pagination__item--first">
                    <button
                      class=${`ais-pagination__link${
                        currentPage === 1 ? " disabled" : ""
                      }`}
                      onclick=${currentPage === 1 ? undefined : goToFirstPage}
                    >
                      &lt;
                    </button>
                  </li>
                `
                : ""
            }
            ${
              props.showPreviousPageLink
                ? html`
                  <li
                    class=${`ais-pagination__item ais-pagination__item--previous${
                      !hasPreviousPage ? " ais-pagination__item--disabled" : ""
                    }`}
                  >
                    <button
                      class=${`ais-pagination__link${
                        !hasPreviousPage ? " disabled" : ""
                      }`}
                      onclick=${
                        currentPage === 1 ? undefined : helpers.goToPreviousPage
                      }
                    >
                      ${"<"}
                    </button>
                  </li>
                `
                : ""
            }
            ${
              props.showNumberedPageLinks
                ? pagesToDisplay.map((pageDetail) => {
                    console.log("showNumberedPageLinks", pageDetail);
                    var classes = ["ais-pagination__item"];
                    var showEllipsis = pageDetail.jumpAfter;
                    if (pageDetail.current) {
                      classes.push("ais-pagination__item--active");
                    }
                    if (pageDetail.jumpAfter) {
                      classes.push("page-jump-over");
                    }

                    var className = classes.join(" ");
                    if (pageDetail.page == helpers.getTotalPages()) {
                      return html``;
                    }

                    return html`
                    <li class=${`${className}`}>
                      <button
                        class="ais-pagination__link"
                        onclick="${() => {
                          !showEllipsis && helpers.goToPage(pageDetail.page);
                        }}"
                      >
                        ${showEllipsis ? "..." : pageDetail.page}
                      </button>
                    </li>
                  `;
                  })
                : ""
            }
            ${
              props.showNextPageLink
                ? html`
              ${
                helpers.getCurrentPage() != helpers.getTotalPages()
                  ? html`
                  <li class="ais-pagination__item">
                        <button
                          class="ais-pagination__link"
                          onclick="${() => {
                            helpers.goToPage(helpers.getTotalPages());
                          }}"
                        >
                          ${helpers.getTotalPages()}
                        </button>
                      </li>
                  `
                  : html`
                  <li class="ais-pagination__item ais-pagination__item--active">
                        <button
                          class="ais-pagination__link"
                          onclick="${() => {
                            helpers.goToPage(helpers.getTotalPages());
                          }}"
                        >
                          ${helpers.getTotalPages()}
                        </button>
                      </li>
                  `
              }
                  <li
                    class=${`ais-pagination__item ais-pagination__item--next${
                      !hasNextPage ? " ais-pagination__item--disabled" : ""
                    }`}
                  >
                    <button
                      class=${`ais-pagination__link${
                        !hasNextPage ? " disabled" : ""
                      }`}
                      onclick=${hasNextPage ? helpers.goToNextPage : undefined}
                    >
                      ${">"}
                    </button>
                  </li>
                `
                : ""
            }
          </ul>
        `;
    },
  },
  pagination: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      if (props.infiniteScroll) {
        if (helpers.canLoadNextResults(props.showLoadNextAfterEvery)) {
          return html`
                  <${args.templates.loadNext} />
                `;
        }
        return "";
      }
      return html`
              <div class="grid__item one-whole collection__pagination pagination">
                <${args.templates.paginationLinks} />
              </div>
            `;
    },
  },
  infoAndActions: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var filterOptions = helpers.getTemplateOptions("filters");

      var getResultsLabel = () => {
        return labels.searchResults.productsCount.replace(
          "{{productsCount}}",
          helpers.getTotalProductsCount()
        );
      };

      return html`
              <div class="collection__tab collection__tab--sort display-flex align-center justify-center">
                <span class="display-flex hide"
                  >Filter
                  <span class="collection__tab--results-no "> ${
                    helpers.getTotalProductsCount()
                      ? "(" + helpers.getTotalProductsCount() + ")"
                      : ""
                  }</span>
                </span>
                ${
                  filterOptions.includeSortOptionsInFilters
                    ? ""
                    : html`
                      <${args.templates.sortOptions} />
                    `
                }
              </div>
            `;
    },
  },
  callbacks: {
    onSuccessfulAPICall: function (response, helpers) {
      var product_card_show_variants = document.querySelectorAll(
        ".product-card__variants--show"
      );
      product_card_show_variants.forEach((variant) => {
        variant.classList.remove("product-card__variants--show");
      });
      setTimeout(function () {
        var filterBarElement = document.querySelector(".collection__tabs");
        var filterWrapperElement = document.querySelector(".filter-wrapper");
        var headerElement = document.querySelector("#shopify-section-header");
        var headerElementHeight = headerElement
          ? headerElement.getBoundingClientRect().height
          : 0;
        var headerHeight = headerElementHeight - 2;
        if (
          filterWrapperElement &&
          window.innerWidth > theme.settings.grid_medium
        ) {
          this.filterWrapper = stickybits(".filter-wrapper", {
            stickyBitStickyOffset: headerHeight,
            useStickyClasses: true,
            useGetBoundingClientRect: true,
          });
        }
      }, 1000);
      return response;
    },
  },
};

var shopifyProductListingPageTemplates = {
  widget: {
    labels: {
      searchResults: {
        heading: {
          standard: "{{resultsCount}} search results for '{{searchTerm}}'",
          corrected:
            "No results for '{{originalSearchTerm}}'. Showing {{resultsCount}} results for '{{correctedSearchTerm}}' instead",
          partialMatches:
            "No products exactly match '{{searchTerm}}'. Showing products that partially match.",
        },
        productsCount: "({{productsCount}})",
        noResultsHeading: {
          heading: "Sorry! We couldn’t find any search results for ",
          subHeading:
            "Try searching again using a different keyword or spelling",
        },
      },
      filters: {
        heading: "Filters",
        clearAllFilters: "Clear all",
        clearIndividualFilter: "Clear",
        drawerFilterToggle: "Filter by",
        rangeFilterValueSeparator: "to",
      },
      sortOptions: {
        sortBy: "Sort by",
      },
      pagination: {
        firstPage: "First",
        previousPage: "Previous",
        nextPage: "Next",
        loadNext: "Load more",
        loading: "Loading...",
      },
    },
    options: {
      includeTagalysCSS: false,
      canAppendQueryStringToUrl: true,
      perPage: 16,
    },
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      if (helpers.isInitialLoading()) {
        return html`
                <${args.templates.loader} />
              `;
      }

      let classes = ["plp", "search-results", "page-width-wide"];
      if (helpers.isFilterDrawerOpen()) {
        classes.push("filter-drawer-opened");
      }

      if (helpers.isLoading()) {
        classes.push("loading");
      }

      if (helpers.canShowFiltersInDrawer()) {
        classes.push("show-filters-in-drawer");
      }

      var className = classes.join(" ");

      return html`
              <div class=${className}>
                <${args.templates.header} />
                <div class="grid grid__uniform collection__container">
                  <div class="grid__item small-down--one-whole medium-up--one-whole filter-wrapper">
                    <div class="flex filters-action-block" style="display:none;">
                      <span class="result-counter">
                        ${
                          helpers.getTotalProductsCount() > 1
                            ? `${helpers.getTotalProductsCount()} Results`
                            : `${helpers.getTotalProductsCount()} Result`
                        }
                      </span>
                      <div id="toggle-tg-filter-v2" class="toggle-tg-filter">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-filter"
                          fill="none"
                          viewBox="0 11 20 20"
                        >
                          <line x1="16.5" y1="17.5" x2="3.5" y2="17.5" stroke="#3F7972" stroke-linecap="round"></line>
                          <line x1="16.5" y1="24.5" x2="3.5" y2="24.5" stroke="#3F7972" stroke-linecap="round"></line>
                          <circle cx="13" cy="24.5" r="2" fill="white" stroke="#3F7972"></circle>
                          <circle cx="7" cy="17.5" r="2" fill="white" stroke="#3F7972"></circle>
                        </svg>
                        <span class="mobile-facets__open-label button-label">Filter </span>
                      </div>
                    </div>
                    <div class="collection__filters">
                      <div class="collection__filter-wrap collection_tg_filter-wrap">
                        <div class="collection-sort-block">
                          <${args.templates.productListHeader} />
                        </div>
                        <${args.templates.filters} />
                      </div>
                    </div>
                  </div>
                  <div class="collection__products grid__item medium-up--one-whole medium-up--four-fifths">
                    <div role="list" class="grid grid--flex display--grid">
                      <${args.templates.products} />
                      <${args.templates.productListFooter} />
                    </div>
                    ${
                      helpers.isFilterDrawerOpen()
                        ? html`
                          <div class="filter-overlay" onclick=${helpers.closeFilterDrawer} />
                        `
                        : ""
                    }
                  </div>
                </div>
                <${args.templates.footer} />
              </div>
            `;
    },
  },
  header: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var filterOptions = helpers.getTemplateOptions("filters");
      return html`
              <div class="plp-header">
                <div class="collection__tabs">
                  <div id="toggle-tg-filter" class="collection__tab collection__tab--filter filter-drawer-toggle">
                    <span class="filter-drawer-btn open-filter-drawer" onclick=${
                      helpers.openFilterDrawer
                    }>
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        class="icon icon-plus"
                      >
                        <path
                          d="M8 3.333v9.334M3.333 8h9.334"
                          stroke="currentColor"
                          stroke-linecap="round"
                          vector-effect="non-scaling-stroke"
                        ></path>
                      </svg>
                      Filter
                      <span class="collection__tab--results-no "> ${
                        helpers.getTotalProductsCount()
                          ? "(" + helpers.getTotalProductsCount() + ")"
                          : ""
                      }</span>
                    </span>
                    <span class="filter-drawer-btn close-filter-drawer" onClick=${
                      props.helpers.closeFilterDrawer
                    }>
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        class="icon icon-minus"
                      >
                        <path
                          d="M3.333 8h9.334"
                          stroke="currentColor"
                          stroke-linecap="round"
                          vector-effect="non-scaling-stroke"
                        ></path></svg
                      >Filter
                      <span class="collection__tab--results-no"> ${
                        helpers.getTotalProductsCount()
                          ? "(" + helpers.getTotalProductsCount() + ")"
                          : ""
                      }</span>
                    </span>
                  </div>
                  <div class="collection__tab collection__tab--clear medium-up--hide">
                    <div class="clear-filters__container" style="display: none;">
                      <button type="reset" class="filter__label clear-filters__btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
                          <path
                            fill="#333"
                            d="M4.5,143.621915 L8.12191516,140 L9,140.878085 L5.37808484,144.5 L9,148.121915 L8.12191516,149 L4.5,145.378085 L0.878084836,149 L-5.68434189e-13,148.121915 L3.62191516,144.5 L-5.68434189e-13,140.878085 L0.878084836,140 L4.5,143.621915 Z"
                            transform="translate(0 -140)"
                          ></path>
                        </svg>
                        <span>Clear Filters</span>
                      </button>
                    </div>
                  </div>
                  <div class="collection__tab collection__tab--grid medium-down--hide medium-up--one-sixth">
                    <div></div>
                  </div>
                  <div class="collection__tab collection__tab--sort medium-up--one-sixth">
                    <div class="collection__tab--sort-overlay">
                      <span>
                        Sort By
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          viewBox="0 0 10 4"
                          class="icon icon--wide icon-chevron-down"
                        >
                          <path fill="none" stroke="#555" d="M9 0L5 4 1 0"></path>
                        </svg>
                      </span>
                    </div>
                    ${
                      filterOptions.includeSortOptionsInFilters
                        ? ""
                        : html`
                          <${args.templates.sortOptions} />
                        `
                    }
                  </div>
                </div>
              </div>
            `;
    },
  },
  productReviews: {
    // Custom template to render variants
    render: function (html, args) {
      var product = args.props.product;
      if (
        typeof product.metafields.okendo == "undefined" ||
        typeof product.metafields.okendo.summaryData == "undefined" ||
        typeof product.metafields.okendo.StarRatingSnippet == "undefined"
      ) {
        return null;
      }
      var reviewCount = product.metafields.okendo.summaryData.value.reviewCount;
      var reviewCountStr = `<span class="reviews-count">(${reviewCount})</span>`;
      if (reviewCount == 0) {
        reviewCountStr = "";
      }
      var starRattingSnippet =
        product.metafields.okendo.StarRatingSnippet.value.replaceAll(
          ["#oke-star-"],
          "#lovisa-star-"
        ) + reviewCountStr;
      return html`<div class="pd-reviews-block" dangerouslySetInnerHTML=${{
        __html: starRattingSnippet,
      }}></div>`;
    },
  },
  product: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var product = props.product;
      var price = product.price;
      var compareAtPrice = product.compare_at_price;

      var productOptions = helpers.getTemplateOptions("product");

      console.log(' helpers.isProductOnSale',  helpers.isProductOnSale(  compareAtPrice, price), compareAtPrice, price )

      // Retrieve the product link using the productPageUrl helper
      var productLink = productOptions.productPageUrl(product);
      var variants = product.variants;
      var tags = product.tags;
      var badge = "";
      var badgeStyles = "";
      var isOnlyInStore = false;
      var sortedVariants = variants.sort((a, b) => {
        return a.price - b.price;
      });
      var firstAvailableVariant = sortedVariants.find(variant => variant.available === true);
      if(firstAvailableVariant){
        price = firstAvailableVariant.price;
        compareAtPrice = firstAvailableVariant.compare_at_price;
      }
      if (tags.length) {
        tags.forEach(function (tag) {
          if (tag === "in-store") {
            isOnlyInStore = true;
          }
          if (tag.includes("offer:")) {
            var badgeParts = tag.split(":");
            badge = badgeParts[1];
            badge = badge.replaceAll("-", " ");
            if (badgeParts[2]) {
              var badgeBackgroundColour = badgeParts[2];
              badgeStyles = `background-color: ${badgeBackgroundColour};`;
            }
            if (badgeParts[3]) {
              var badgeTextColour = badgeParts[3];
              badgeStyles = `${badgeStyles} color: ${badgeTextColour};`;
            }
          }
        });
      }
      if (!badge) {
        var collections = product.collections;
        var collectionsMetaObject = window.theme.collectionMetaobjects;
        var tempbadge = false;
        for (var i = 0; i < collectionsMetaObject.length; i++) {
          for (var j = 0; j < collections.length; j++) {
            if (
              collections[j].title == collectionsMetaObject[i].collection_name
            ) {
              badge = collectionsMetaObject[i].badge_text;
              badgeStyles = `background-color:  ${collectionsMetaObject[i].badge_background_color}`;
              badgeStyles = `${badgeStyles}; color:  ${collectionsMetaObject[i].badge_text_color};`;
              tempbadge = true;
              break;
            }
          }
          if (tempbadge) {
            break;
          }
        }
      }

      return html`
                    <div class="grid__item medium-down--one-half large-up--one-whole html2">
                      <div class="product-card product-card--quick" data-sku="${
                        product.variants[0].sku
                      }">
                        <button
                          data-product="${product.id}"
                          data-product-title="${product.title}"
                          data-variant="${product.variants[0].id}"
                          aria-label="Add ${product.title} to wishlist"
                          class="product-card__wishlist-icon smartwishlist"
                        ></button>
                        <div class="product-card__image">
                          <div class="product-card__image--wrapper">
                            <a href="${productLink}" title="${product.title}">
                              ${
                                product.images.length > 1
                                  ? html`
                                    <div class="image_slider">
                                      <span class="primary-image">
                                        <div class="product-card__image--cover"></div>
                                        <img
                                          src="${product.images[0].src}"
                                          class="component-image__image product-image"
                                          alt="${product.title}"
                                        />
                                      </span>
                                      <span class="secondary-image">
                                        <div class="product-card__image--cover"></div>
                                        <img
                                          src="${product.images[1].src}"
                                          class="component-image__image"
                                          alt="${product.title}"
                                        />
                                      </span>
                                    </div>
                                  `
                                  : html`
                                    <img
                                      src="${product.featured_image?.src}"
                                      class="component-image__image"
                                      alt="${product.title}"
                                    />
                                  `
                              }
                            </a>
                          </div>
                          <div class="product-card__actions">
                              <${
                                args.templates.addToCartForm
                              } product=${product} />
                              <${
                                args.templates.productObj
                              } product=${product} />
                            </div>
                        </div>
                        <div class="product-card__info">
                          <div class="product-card__details">
                            <div class="product-card__text">
                              <div data-oke-reviews-product-listing-rating=""></div>
                              <h4 class="product-card__title taglays">
                                <a href="${productLink}"><span>${
        product.title
      }</span></a>
                              </h4>
                              <div class="product-card__price">
                                ${
                                  helpers.isStorefrontAPICallPending()
                                    ? html`
                                      <span class="skeleton-box"></span>
                                    `
                                    : html`
                                      <span class=${`product-prices ${
                                        helpers.isProductOnSale(
                                          compareAtPrice,
                                          price
                                        )
                                          ? " discounted"
                                          : " full-price"
                                      }`}>
                                        ${
                                          helpers.isProductOnSale(
                                            compareAtPrice,
                                            price
                                          )
                                            ? html`
                                              <span class="sale-price-text-color product-price-discounted" dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                     price
                                                   ),
                                               }}
                                              />
                                            `
                                            : ""
                                        }
                                        <span class="product-price-regular"
                                        dangerouslySetInnerHTML=${{
                                                 __html:
                                                   helpers.formatCurrency(
                                                    compareAtPrice === null
                                                      ? price
                                                      : compareAtPrice
                                                  ),
                                               }}
                                              />
                                      </span>
                                    `
                                } ${
        helpers.isProductOnSale(compareAtPrice, price)
          ? html`
                                <span class="product-per-off ${
                                  window.theme.tagalysShowPerOffMobile
                                    ? "show-per-off-mobile"
                                    : ""
                                }${
              window.theme.tagalysShowPerOffDesktop
                ? " show-per-off-desktop"
                : ""
            }">
                                  ${Math.round(
                                    ((compareAtPrice - price) * 100) /
                                      compareAtPrice
                                  )}% Off
                                </span>
                              `
          : ""
      }

                            <${
                              args.templates.productReviews
                            } product=${product} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
    },
  },
  filters: {
    options: {
      collapsible: true,
      includeSortOptionsInFilters: false,
      autoCollapse: true,
      showAppliedFilters: true,
      showClearAllFilters: true,
      showClearActionForIndividualFilters: true,
      showMatchingProductsCount: true,
      defaultExpandedFilters: [],
      showFiltersInDrawer: () => {
        return window.innerWidth <= 768;
      },
    },
    render: function (html, args) {
      var props = args.props;
      var labels = args.labels;
      var helpers = props.helpers;

      var filters = helpers.getFilters();
      var appliedFilters = helpers.getAppliedFilters(true);
      var showClearAllFiltersAction =
        props.showClearAllFilters && appliedFilters.length;
      var classes = ["filters"];
      if (props.collapsible) {
        classes.push("collapsible");
      }

      var className = classes.join(" ");
      return html`
              <div class="collection__filter-actions">
                ${
                  props.showAppliedFilters
                    ? html`
                      <${args.templates.appliedFilters} />
                    `
                    : ""
                }
                ${
                  showClearAllFiltersAction
                    ? html`
                      <div class="filter__label clear-all-filters" onclick=${() => {
                        helpers.clearAllFilters();
                        clearAllFilterDataLayerEvent(props);
                      }}>
                        ${labels.filters.clearAllFilters}
                      </div>
                    `
                    : ""
                }
              </div>
              <div class="collection-filters-block">
                <${args.templates.filtersHeader} />

                ${
                  props.includeSortOptionsInFilters === "top"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
                ${filters.map(
                  (filter) =>
                    html`
                      <${args.templates.filter} filter=${filter} />
                    `
                )}
                ${
                  props.includeSortOptionsInFilters === true ||
                  props.includeSortOptionsInFilters === "bottom"
                    ? html`
                      <${args.templates.sortOptionInFilters} />
                    `
                    : ""
                }
              </div>
            `;
    },
    callbacks: {
      afterEveryRender: function (helpers) {
        const searchInputs = document.querySelectorAll(".search__input");
        if (!searchInputs || searchInputs.length === 0) {
          return;
        }

        searchInputs.forEach((inputEL) => {
          inputEL.addEventListener("focus", function () {
            const filtersDrawer = document.querySelector(
              ".show-filters-in-drawer"
            );
            if (filtersDrawer && helpers.isFilterDrawerOpen()) {
              helpers.closeFilterDrawer();
            }
          });
        });

        //customTagalysActionEvents(helpers);
        var product_card_show_variants = document.querySelectorAll(
          ".product-card__variants--show"
        );
        product_card_show_variants.forEach((variant) => {
          variant.classList.remove("product-card__variants--show");
        });

        setTimeout(function () {
          var relatedProductCards = document.querySelectorAll(".product-card");
          if (relatedProductCards && relatedProductCards.length) {
            relatedProductCards.forEach((productCardElement) => {
              new window.theme.ProductCard(productCardElement, "tagalys");
            });
          }
        }, 2000);
      },
    },
  },
  filtersHeader: {
    render: function (html, args) {
      var props = args.props;
      var labels = args.labels;
      return html``;
    },
  },
  appliedFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      var appliedFilters = helpers.getAppliedFilters(true);
      if (!appliedFilters.length) {
        return html``;
      }

      return html`
              <ul class="applied-filters unstyled-list">
                ${appliedFilters.map((appliedFilter) => {
                  if (appliedFilter.type === "range") {
                    return html`
                      <li onClick=${() => {
                        helpers.clearFilter(appliedFilter.id);
                        removeFilterDataLayerEvent(props, appliedFilter.id);
                      }} class="applied-filter">
                        <span class="applied-filter-label" 
                        dangerouslySetInnerHTML=${{
                          __html:
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_min,
                            appliedFilter.currency
                          )+'<span class="price-applied-space">-</span>'+
                            helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_max,
                            appliedFilter.currency
                          ),
                        }} />
                        <span class="applied-filter-action-clear">
                          <${args.templates.closeIcon} />
                        </span>
                      </li>
                    `;
                  }
                  return appliedFilter.items.map((filterItem) => {
                    return html`
                      <li
                        class="display-flex applied-filter"
                        onClick=${() => {
                          helpers.clearFilter(appliedFilter.id, filterItem.id);
                          removeFilterDataLayerEvent(
                            props,
                            appliedFilter.id,
                            filterItem
                          );
                        }}
                      >
                        <span class="filter__label applied-filter-label">
                          ${filterItem.label}
                        </span>
                        <span class="filter__label applied-filter-action-clear">
                          <${args.templates.closeIcon} />
                        </span>
                      </li>
                    `;
                  });
                })}
              </ul>
            `;
    },
  },
  closeIcon: {
    render: function (html, args) {
      return html`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Exclude" fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM8.39406 3.76859C8.59945 3.98896 8.58731 4.33411 8.36694 4.5395L6.77087 6.02708L8.25845 7.62315C8.46384 7.84352 8.45169 8.18867 8.23132 8.39406C8.01095 8.59945 7.6658 8.58731 7.46041 8.36694L5.97283 6.77087L4.37676 8.25845C4.15639 8.46384 3.81124 8.45169 3.60585 8.23132C3.40046 8.01095 3.4126 7.6658 3.63297 7.46041L5.22904 5.97283L3.74146 4.37676C3.53607 4.15639 3.54822 3.81124 3.76859 3.60585C3.98896 3.40046 4.33411 3.4126 4.5395 3.63297L6.02708 5.22904L7.62315 3.74146C7.84352 3.53607 8.18867 3.54822 8.39406 3.76859Z" fill="#333333"/></svg>`;
    },
  },
  filter: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var classes = ["collection__filter", "filter"];
      var isCollapseOpen = false;
      if (props.collapsible) {
        isCollapseOpen = helpers.isCollapsibleFilterExpanded(props.filter.id);
        if (isCollapseOpen) {
          classes.push("expanded");
        } else {
          classes.push("collapsed");
        }
      }
      var className = classes.join(" ");
      return html`
              <div class=${className} data-filter-id=${props.filter.id}>
                <${args.templates.filterHeader} filterHeading=${props.filter.label} filterId=${props.filter.id} />
                <${args.templates.filterItems} filter=${props.filter} />
              </div>
            `;
    },
  },
  filterHeader: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var filterOptions = helpers.getTemplateOptions("filters");
      var showClearActionForIndividualFilters =
        filterOptions.showClearActionForIndividualFilters &&
        helpers.isFilterApplied(props.filterId);
      var toggleCollapsibleFilter = () => {
        helpers.toggleCollapsibleFilter(props.filterId);
      };
      var clearFilter = (event) => {
        event.stopPropagation();
        helpers.clearFilter(props.filterId);
        removeFilterDataLayerEvent(props, props.filterId);
      };
      return html`
              <div
                onClick=${
                  filterOptions.collapsible
                    ? toggleCollapsibleFilter
                    : undefined
                }
                class="filter__label filter-header"
              >
                <h3 class="filter-heading filter__button">
                  ${props.filterHeading}
                </h3>
                <div class="filter-actions">
                  ${
                    showClearActionForIndividualFilters
                      ? html`
                        <div onClick=${clearFilter} class="filter-action-clear">
                          ${labels.filters.clearIndividualFilter}
                        </div>
                      `
                      : ""
                  }
                  <span class="filter-action-toggle-collapse">
                    ${
                      filterOptions.collapsible
                        ? html`
                          <${args.templates.downArrow} />
                        `
                        : ""
                    }
                  </span>
                </div>
              </div>
            `;
    },
  },
  filterItems: {
    render: function (html, args) {
      var props = args.props;
      if (props.filter.type === "checkbox") {
        return html`
                <div class="filter__list filter-body filter-body-checkboxes ">
                  <${args.templates.filterCheckBoxes} filterId=${props.filter.id} filterItems=${props.filter.items} />
                </div>
              `;
      }
      return html`
              <div class="filter__list filter-body filter-body-range">
                <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
              </div>
            `;
    },
  },
  filterCheckBoxes: {
    render: function (html, args) {
      var props = args.props;
      return html`
              <ul class="filter-checkboxes">
                ${props.filterItems.map((filterItem) => {
                  return html`
                  <${args.templates.checkboxFilterItem}
                    filterId=${props.filterId}
                    filterItem=${filterItem}
                  >
                  ${
                    filterItem.selected && filterItem.items
                      ? html`
                          <${args.templates.filterCheckBoxes}
                            filterId=${props.filterId}
                            filterItems=${filterItem.items}
                          />
                        `
                      : ""
                  }
                </${args.templates.checkboxFilterItem}>
              `;
                })}
              </ul>
            `;
    },
  },
  checkboxFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;

      const onFilterClick = (event) => {
        event.stopPropagation();
        if (props.filterItem.selected) {
          helpers.clearFilter(props.filterId, props.filterItem.id);
          removeFilterDataLayerEvent(props, props.filterId, props.filterItem);
        } else {
          helpers.applyFilter(props.filterId, props.filterItem.id);
          applyFilterDataLayerEvent(props);
        }
      };

      return html`
              <li class="filter-item" data-filter-item-id=${
                props.filterItem.id
              } onClick=${onFilterClick}>
                <span class="filter__type filter-checkbox-and-label">
                  <input class="checkbox" checked=${
                    props.filterItem.selected
                  } type="checkbox" />
                  <span class="filter-item-label-and-count">
                    <span class="filter-item-label">${
                      props.filterItem.label
                    }</span>
                    ${
                      props.showMatchingProductsCount
                        ? html`
                          <span class="filter-item-count">(${props.filterItem.count})</span>
                        `
                        : ""
                    }
                  </span>
                </span>
                ${props.children}
              </li>
            `;
    },
  },
  rangeSliderFilterItem: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var priceLabel = "Any";

      if (
        props.sliderInputValues[0] > props.filter.min &&
        props.sliderInputValues[1] < props.filter.max
      ) {
        priceLabel =
          "Between " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[0],
            props.filter.currency
          ) +
          " - " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[1],
            props.filter.currency
          );
      } else if (props.sliderInputValues[0] > props.filter.min) {
        priceLabel =
          "Above " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[0],
            props.filter.currency
          );
      } else if (props.sliderInputValues[1] < props.filter.max) {
        priceLabel =
          "Below " +
          helpers.labelFormatter(
            props.filter.display_format,
            props.sliderInputValues[1],
            props.filter.currency
          );
      }
      var minPriceValue = window.Currency.formatMoney(
        props.sliderInputValues[0] * 100,
        window.Currency.moneyFormats[window.Shopify.currency.active]
          .money_format
      );
      var maxPriceValue = window.Currency.formatMoney(
        props.sliderInputValues[1] * 100,
        window.Currency.moneyFormats[window.Shopify.currency.active]
          .money_format
      );
      var priceValueLeft = "0%";
      if (props.sliderInputValues[0] > props.filter.min) {
        priceValueLeft =
          ((props.sliderInputValues[0] - props.filter.min) / props.filter.max) *
          100;
        priceValueLeft += "%";
      }
      var priceValueRight = "0%";
      if (props.sliderInputValues[1] < props.filter.max) {
        // eslint-disable-next-line no-mixed-operators
        priceValueRight =
          (100 - props.sliderInputValues[1] / props.filter.max) * 100;
        priceValueRight += "%";
      }

      var priceValueLeftClass = "";
      var priceValueRightClass = "";

      if (document.querySelector(".noUi-handle-lower.noUi-active")) {
        priceValueLeftClass = "drag";
      }
      if (document.querySelector(".noUi-handle-upper.noUi-active")) {
        priceValueRightClass = "drag";
      }

      return html`
              <div class="range-slider filter-item">
                <span class="max-range-info">${priceLabel}</span>
                <div class="price-range-value" style="">
                  <span class="price-range__label--min-price ${priceValueLeftClass}" style="left: ${priceValueLeft};">
                    ${minPriceValue}
                  </span>
                  <span class="price-range__label--max-price ${priceValueRightClass}" style="right: ${priceValueRight};">
                    ${maxPriceValue}
                  </span>
                </div>
                <div ref=${props.sliderRef} />
                <div></div>
                <div class="price-range__input-group" style="display:none;">
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">$</span>
                    <input
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=${props.sliderInputValues[0]}
                      value=${props.sliderInputValues[0]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMinChange}
                      onfocus=${(this.value = "")}
                    />
                    <label style="display:none;">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.min,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                  <span class="to">${
                    labels.filters.rangeFilterValueSeparator
                  }</span>
                  <div class="price-range__input input-prefix input-container">
                    <span class="input-prefix__value">$</span>
                    <input
                      type="number"
                      inputmode="numeric"
                      class="input-prefix__field field__input pr-input"
                      placeholder=${props.sliderInputValues[1]}
                      value=${props.sliderInputValues[1]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMaxChange}
                    />
                    <label style="display:none;">
                      ${helpers.labelFormatter(
                        props.filter.display_format,
                        props.filter.max,
                        props.filter.currency
                      )}
                    </label>
                  </div>
                </div>
              </div>
            `;
    },
  },
  sortOptionInFilters: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;

      var filterOptions = helpers.getTemplateOptions("filters");
      var appliedSortOption = helpers.getAppliedSortOption();
      var sortOptions = helpers.getSortOptions();

      let classes = ["filter"];
      let isCollapseOpen = false;
      if (filterOptions.collapsible) {
        isCollapseOpen = helpers.isCollapsibleFilterExpanded("sort_options");
        if (isCollapseOpen) {
          classes.push("expanded");
        } else {
          classes.push("collapsed");
        }
      }
      var className = classes.join(" ");

      return html`
              <div data-filter-id="sort_options" class=${className}>
                <${args.templates.filterHeader} filterHeading=${
        labels.sortOptions.sortBy
      } filterId=${"sort_options"} />
                <div class="filter-body filter-body-checkboxes">
                  <ul class="filter-checkboxes">
                    ${sortOptions.map((sortOption) => {
                      const checked = sortOption.id === appliedSortOption.id;
                      return html`
                        <li
                          class="filter-item"
                          data-filter-item-id=${sortOption.id}
                          onClick=${() => {
                            helpers.applySortOption(sortOption.id);
                            clickSortOptionDataLayerEvent(helpers);
                          }}
                        >
                          <span class="filter-checkbox-and-label">
                            <input class="checkbox" checked=${checked} type="checkbox" />
                            <span class="filter-item-label-and-count">
                              <span class="filter-item-label">${
                                sortOption.label
                              }</span>
                            </span>
                          </span>
                        </li>
                      `;
                    })}
                  </ul>
                </div>
              </div>
            `;
    },
  },
  downArrow: {
    // eslint-disable-next-line no-unused-vars
    render: function (html, args) {
      return html`
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                viewBox="0 0 10 4"
                class="down-arrow icon icon--wide icon-chevron-down"
              >
                <path fill="none" stroke="#555" d="M9 0L5 4 1 0"></path>
              </svg>
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                viewBox="0 0 13 6"
                class="icon icon--wide icon-chevron-up-2"
              >
                <path fill="none" stroke="#333" d="M1 6l5.5-6L12 6"></path>
              </svg>
            `;
    },
  },
  addToCartForm: {
    render: function (html, args) {
      var product = args.props.product;
      var variants = product.variants;
      var isOnlyInStore = false;
      var tags = product.tags;
      if (tags.length) {
        tags.forEach(function (tag) {
          if (tag === "in-store") {
            isOnlyInStore = true;
          }
        });
      }

      return html`
              <form action="${
                window.plp_vars.cart_add_url
              }" method="post" enctype="multipart/form-data" class="form">
                <input type="hidden" name="quantity" value="1" />
                <${args.templates.variantSelect} product=${product} />
                <${args.templates.variantOption} product=${product} />
                ${
                  variants.length > 1
                    ? html`
                      <button class="btn--icon  product__add--show-variants" type="button" aria-label="Add to bag">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 15.75H6C3.92925 15.75 2.25 14.0707 2.25 12V6.47549C2.25 6.06149 2.586 5.72549 3 5.72549H15C15.414 5.72549 15.75 6.06149 15.75 6.47549V12C15.75 14.0707 14.0707 15.75 12 15.75Z"
                            stroke="#111111"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 8.25V3.75C12 2.92125 11.3288 2.25 10.5 2.25H7.5C6.67125 2.25 6 2.92125 6 3.75V8.25"
                            stroke="#111111"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                      <button
                        type="button"
                        class="product__add--mobile product__add--show-variants"
                        aria-label="Add to bag"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 15.75H6C3.92925 15.75 2.25 14.0707 2.25 12V6.47549C2.25 6.06149 2.586 5.72549 3 5.72549H15C15.414 5.72549 15.75 6.06149 15.75 6.47549V12C15.75 14.0707 14.0707 15.75 12 15.75Z"
                            stroke="#111111"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 8.25V3.75C12 2.92125 11.3288 2.25 10.5 2.25H7.5C6.67125 2.25 6 2.92125 6 3.75V8.25"
                            stroke="#111111"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    `
                    : html`
                      <button
                        class="btn--icon product__add"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="Add to bag"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
                          <g clip-path="url(#clip0_399_21395)">
                            <path d="M0.442217 5.77556H12.3578V14.2311C12.3578 14.9638 11.7638 15.5578 11.0311 15.5578H1.76887C1.03618 15.5578 0.442217 14.9638 0.442217 14.2311V5.77556Z" stroke="#4D4D4D" stroke-width="0.884434"/>
                            <path d="M3.83984 8.53334V2.89183C3.83984 1.58927 4.89578 0.53334 6.19833 0.53334H6.60135C7.90391 0.53334 8.95984 1.58927 8.95984 2.89183V8.53334" stroke="#4D4D4D" stroke-width="0.884434"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_399_21395">
                              <rect width="12.8" height="16" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                      <button
                        class="product__add--mobile"
                        type="submit"
                        name="add"
                        data-add-to-cart=""
                        aria-label="Add to bag"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
                          <g clip-path="url(#clip0_399_21395)">
                            <path d="M0.442217 5.77556H12.3578V14.2311C12.3578 14.9638 11.7638 15.5578 11.0311 15.5578H1.76887C1.03618 15.5578 0.442217 14.9638 0.442217 14.2311V5.77556Z" stroke="#4D4D4D" stroke-width="0.884434"/>
                            <path d="M3.83984 8.53334V2.89183C3.83984 1.58927 4.89578 0.53334 6.19833 0.53334H6.60135C7.90391 0.53334 8.95984 1.58927 8.95984 2.89183V8.53334" stroke="#4D4D4D" stroke-width="0.884434"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_399_21395">
                              <rect width="12.8" height="16" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-checkmark"
                          viewBox="0 0 130.2 130.2"
                        >
                          <path
                            class="path"
                            fill="none"
                            stroke="#fff"
                            stroke-width="13"
                            stroke-linecap="square"
                            stroke-miterlimit="10"
                            d="M100.2 40.2L51.5 88.8 29.8 67.5"
                          ></path>
                        </svg>
                      </button>
                    `
                }
              </form>
            `;
    },
  },
  variantOption: {
    render: function (html, args) {
      var product = args.props.product;
      var variants = product.variants;
      return html`
          <div class="product-card__variant-picker product-card__variant-picker--with-options">
            <span class="variant-picker__message visually-hidden" tabindex="-1"
              >Please select an option below to add to cart.</span>
            <div role="list" class="product-card__variants">
              ${variants.map((variant) => {
                if (variant.available) {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button class="btn btn--text add-product-variant" data-variant-id="${variant.id}">
                        ${variant.title}
                      </button>
                    </div>
                  `;
                } else {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button
                        class="btn btn--text add-product-variant"
                        disabled="disabled"
                        data-variant-id="${variant.id}"
                      >
                        ${variant.title}
                      </button>
                    </div>
                  `;
                }
              })}
            </div>
            <div role="list" class="product-card__mobile-variants">
              ${variants.map((variant) => {
                if (variant.available) {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button class="btn btn--text add-product-variant" data-variant-id="${variant.id}">
                        ${variant.title}
                      </button>
                    </div>
                    <div role="listitem">
                      <button class="product-card__variant add-product-variant" data-variant-id="${variant.id}">
                        <span class="product-card__variant-text">${variant.title}</span>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-checkmark"
                          viewBox="0 0 130.2 130.2"
                        >
                          <path
                            class="path"
                            fill="none"
                            stroke="#fff"
                            stroke-width="13"
                            stroke-linecap="square"
                            stroke-miterlimit="10"
                            d="M100.2 40.2L51.5 88.8 29.8 67.5"
                          />
                        </svg>
                      </button>
                    </div>
                  `;
                } else {
                  return html`
                    <div role="listitem" class="product-card__variant-container">
                      <button
                        class="btn btn--text add-product-variant"
                        disabled="disabled"
                        data-variant-id="${variant.id}"
                      >
                        ${variant.title}
                      </button>
                    </div>
                    <div role="listitem">
                      <button class="product-card__variant add-product-variant" data-variant-id="${variant.id}">
                        <span class="product-card__variant-text">${variant.title}</span>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          class="icon icon-checkmark"
                          viewBox="0 0 130.2 130.2"
                        >
                          <path
                            class="path"
                            fill="none"
                            stroke="#fff"
                            stroke-width="13"
                            stroke-linecap="square"
                            stroke-miterlimit="10"
                            d="M100.2 40.2L51.5 88.8 29.8 67.5"
                          />
                        </svg>
                      </button>
                    </div>
                  `;
                }
              })}
            </div>
          </div>
        `;
    },
  },
  variantSelect: {
    render: function (html, args) {
      var product = args.props.product;
      var variants = product.variants;
      return html`
              <select name="id" class="no-js" aria-label="Select variant" data-product-select>
                ${variants.map((variant, i) => {
                  return html`
                    <option ${
                      i === 0 ? 'selected="selected"' : ""
                    } data-i-${i} value="${variant.id}"
                      >${variant.title}</option
                    >
                  `;
                })}
              </select>
            `;
    },
  },
  productObj: {
    // Custom template to render variants
    render: function (html, args) {
      var product = args.props.product;
      return html`
              <div style="display:none;" data-product-json>
                ${JSON.stringify(product)}
              </div>
            `;
    },
  },
  products: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var products = helpers.getProducts();

      return html`
        ${products.map((product, index) =>
          product.images.length > 0
            ? html`
                <${args.templates.product} key=${index} product=${product} />
              `
            : ""
        )}
      `;
    },
    callbacks: {
      // eslint-disable-next-line no-unused-vars
      afterInitialRender: function (helpers) {
        setTimeout(function () {
          var relatedProductCards = document.querySelectorAll(".product-card");
          if (relatedProductCards && relatedProductCards.length) {
            relatedProductCards.forEach((productCardElement) => {
              new window.theme.ProductCard(productCardElement, "tagalys");
            });
          }
        }, 2000);
      },
    },
  },
  sortOptions: {
    render: function (html, args) {
      var props = args.props;
      var labels = args.labels;
      var helpers = props.helpers;
      var sortOptions = helpers.getSortOptions();
      var appliedSortOption = helpers.getAppliedSortOption();

      var applySortOption = (event) => {
        helpers.applySortOption(event.target.value);
        clickSortOptionDataLayerEvent(helpers);
        // plpDataLayerEvents
        theme.PLPDataLayerEvents.setPLPDataLayerEvent({
          event: 'item_list_filter',
          interaction_type: 'Sort',
          list_sort_order: event.target.value
        });
      };

      return html`
              <div class="sort-options-container">
                <select class="sort-options" data-lvtrack-entity="sort" value=${
                  appliedSortOption.id
                } onchange=${applySortOption}>
                  ${sortOptions.map((sortOption) => {
                    return html`
                      <option value=${sortOption.id}>${sortOption.label}</option>
                    `;
                  })}
                </select>
              </div>
            `;
    },
  },

  productListHeader: {
    render: function (html, args) {
      return html`
              <${args.templates.infoAndActions} />
            `;
    },
  },
  noResults: {
    options: "",
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      return html`
              <div class="no-results page-width-wide">
                <div class="no-results-heading tg-no-result-heading">
                  ${labels.searchResults.noResultsHeading.heading}
                  <b>"${helpers.getQuery()}"</b>
                  <span class="tg-no-result-subheading">
                    ${labels.searchResults.noResultsHeading.subHeading}
                  </span>
                </div>
                <div class="tg-no-result-products-wrapper">
                  <div class="tg-no-result-products-widget-wrapper">
                    <${args.templates.noResultsWidgets} />
                  </div>
                </div>
              </div>
            `;
    },
  },
  infoAndActions: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      var filterOptions = helpers.getTemplateOptions("filters");
      return html`
              <div class="collection__tab collection__tab--sort display-flex align-center justify-center">
                
                ${
                  filterOptions.includeSortOptionsInFilters
                    ? ""
                    : html`<${args.templates.sortOptions} />`
                }
              </div>
            `;
    },
  },
  pagination: {
    render: function (html, args) {
      var props = args.props;
      var helpers = props.helpers;
      var labels = args.labels;
      if (helpers.canLoadNextResults(props.showLoadNextAfterEvery)) {
        return html`<div class="text-center m-b-xs">
            <button class="load-next btn btn--primary" onclick=${
              props.helpers.loadNextPage
            }>
              ${
                helpers.isLoading()
                  ? labels.pagination.loading
                  : labels.pagination.loadNext
              }
            </button></div>
          `;
      }
      return null;
    },
  },
  callbacks: {
    onSuccessfulAPICall: function (response, helpers) {
      var product_card_show_variants = document.querySelectorAll(
        ".product-card__variants--show"
      );
      product_card_show_variants.forEach((variant) => {
        variant.classList.remove("product-card__variants--show");
      });
      setTimeout(function () {
        var filterBarElement = document.querySelector(".collection__tabs");
        var filterWrapperElement = document.querySelector(".filter-wrapper");
        var headerElement = document.querySelector("#shopify-section-header");
        var headerElementHeight = headerElement
          ? headerElement.getBoundingClientRect().height
          : 0;
        var headerHeight = headerElementHeight - 2;
        if (
          filterWrapperElement &&
          window.innerWidth > theme.settings.grid_medium
        ) {
          this.filterWrapper = stickybits(".filter-wrapper-old", {
            stickyBitStickyOffset: headerHeight,
            useStickyClasses: true,
            useGetBoundingClientRect: true,
          });
        }
      }, 1000);
      return response;
    },
  },
};

// helper for initializing the failover widget
TagalysCustomisationsCollection.initializeShopifyProductListingPage =
  function () {
    return Tagalys.UIWidgets.ShopifyCollection.init(plp_selector, {
      params: plp_params,
      templates: shopifyProductListingPageTemplates,
    });
  };

// helper for initializing the primary widget
TagalysCustomisationsCollection.initializeProductListingPage = function () {
  Tagalys.UIWidgets.Collection.init(plp_selector, {
    params: plp_params,
    failover:
      TagalysCustomisationsCollection.initializeShopifyProductListingPage,
    templates: productListingPageTemplates,
    forceFailover: window.tagalysForceFailover,
  });
};
